import {
  ACCOUNT_ROLES,
  ACCOUNT_TABLE_ACTIONS,
  ACCOUNT_TYPE,
  ACTIONS,
  ACTIVE_PROVIDER_SEARCHES,
  ACTIVE_PROVIDER_SEARCH_VERSIONS,
  ACTIVE_SEARCH_MERGE_STATUSES,
  ADMISSIONS_ACTION_SCREENS,
  ADMISSIONS_CARE_LEVEL_APPLICATION,
  ADMISSIONS_FORM_SOLUTIONS,
  ADMISSIONS_FORM_STATUS,
  ADMISSIONS_FORM_TYPES,
  ADMISSIONS_INFO_SCREENS,
  ADMISSIONS_MODALS,
  ADMISSIONS_STEPS,
  AHB_MESSAGE_STATUS,
  AHB_MESSAGE_TYPE,
  AHB_PROCEDURE_ID,
  AHB_PROCESSING_CODE,
  AHB_RESPONSE_STATUS,
  AHB_WITHDRAW_REASON,
  AI_FORM_NAME,
  ALGOLIA_INDICES,
  ANALYTICS_SECTIONS,
  ASSESSMENT_SLUG,
  ASSESSMENT_VARIANTS,
  AT_HOME_SITUATION,
  AUCTION_REQUEST_ORIGIN,
  AUCTION_STEPPER_STEPS,
  BACKEND,
  CAREPROVIDER_STATUSES,
  CAREPROVIDER_TAB_TYPE_DIRECT,
  CARESEEKER_TYPE,
  CARE_LEVELS,
  CARE_LEVEL_FORMS,
  CHAT_MESSAGE_ROLES,
  CLINICAL_CONSULTATION_ACTION,
  CONSULTANT_STATUSES,
  CONTRADICTION_STATUS,
  COUNTRY_DE,
  CREATE_PATIENT_ROLES,
  DOCS_FEEDBACK_RATING_TYPES,
  DOCS_FORM_NAMES,
  DOCS_FORM_STATUS,
  DRV_TRAVEL_TYPES,
  DTA_MEDICAL_FORM_APPROVED_BY,
  EARLY_REHAB_CRITERIA,
  EMPLOYMENT_STATUS,
  EXTRACT_OCR_STATUS,
  FIELD_CREATION_TYPE,
  FILE_CATEGORIES,
  FILE_DELETION_TYPES,
  FILE_DETAILS_TABS,
  FILE_ERROR_TYPE,
  FILE_SCOPE,
  FILE_SHARE_MODE_KINDS,
  FILE_TABLE_ACTIONS,
  FORM_DOWNLOADED_PDF_NAMES,
  FORM_PDF_PATHS,
  FUNCTION_DIAGNOSIS_PRIORITIES,
  GENDER,
  GLOSSARY_SECTIONS,
  GRANT_STATUSES,
  GUARDIAN,
  HEALTH_INSURANCE_STATUS,
  HEALTH_INSURANCE_TYPES,
  HOME_CARE_SITUATION,
  INDEX_DB_SESSION_KEYS,
  INDEX_DB_SESSION_KEYS_VERSION,
  INDEX_DB_TABLES,
  INTEGRATION_EVENT_STATUSES,
  INTEGRATION_EVENT_TYPES,
  LACK_OF_CAPACITY_DOCUMENT,
  LEGAL_DOCUMENTS,
  LEGAL_GUARDIAN,
  LIVING_SITUATIONS,
  LOGO_COLOR_SCHEMA,
  MARITAL_STATUS,
  MUSCOSKELETAL_RESILIENCE,
  NOTIFICATION_TYPES,
  ORIGIN,
  OUTPATIENT_NOT_POSSIBLE_REASONS,
  PAGINATION_RESULT_COUNTS,
  PATIENT_ACTION,
  PATIENT_DOCUMENTS,
  PREDICAMENT_STATES,
  PREDICAMENT_STATE_NO,
  PREDICAMENT_STATE_YES,
  PREDICAMENT_YES_NO_UNKNOWN,
  PREDICT_ACTIONS,
  PREDICT_PATIENT_STATUS,
  PREDICT_TREND,
  PRIOR_EMPLOYMENT_STATUS,
  PRODUCT_FEATURES,
  PRODUCT_FEATURE_STATUSES,
  PROVIDER_SEARCHES,
  PROVIDER_SEARCH_PAGES,
  PROVIDER_SEARCH_VERSIONS,
  RECARE_FILE_TYPE,
  REDIRECT_REASON_GENERIC_ERROR,
  REDIRECT_REASON_LINK_EXPIRED,
  REDIRECT_REASON_NOT_AUTHORIZED,
  REHAB_ADMISSION,
  REHAB_DIRECTIVE_TYPE,
  REHAB_FOCUS,
  REHAB_FORM_FILE_NAMES,
  REHAB_FORM_NAMES,
  REHAB_FORM_PATHS,
  REHAB_TRIGGERING_EVENT,
  REQUESTED_REHAB_SERVICE,
  REQUESTED_REHAB_SERVICE_TYPE,
  REQUEST_ACTION_VARIANTS,
  REQUEST_CHIP_STATUSES,
  REQUEST_FORM_FIELDS,
  REQUIRED_CARE_BASIC_TYPES,
  REQUIRED_CARE_TYPES,
  ROOM_TYPES,
  SCHEMA_VERSION,
  SEALD_ENCRYPTION_ACCESS_STATUS,
  SEARCH_ACTION_DISPLAY_FILES_TAB,
  SEARCH_MERGE_BANNERS,
  SEARCH_MERGE_STATUSES,
  SEARCH_TABLE_ROW_COUNTS,
  SEARCH_TABLE_TABLES,
  SEARCH_TYPES,
  SHORT_TERM_GRANT_STATUSES,
  SIDE_LOCALIZATION,
  SOLUTIONS,
  SORTING_MAP,
  SOURCE_DOCUMENT_SOURCES,
  SPECIAL_CARE_NEEDS,
  SPECIAL_REQUIREMENTS,
  TABLES_PAYLOAD,
  TABLE_PAYLOAD_ACCEPTED,
  TABLE_PAYLOAD_CONTACTED,
  TABLE_PAYLOAD_DECLINED,
  TABLE_PAYLOAD_FILTERED,
  TABLE_PAYLOAD_POTENTIAL,
  TABLE_PAYLOAD_REJECTED,
  TABLE_PAYLOAD_VALIDATED,
  TOKEN_INVALID_REASONS,
  TRANSPORTATION_SUBTYPE,
  TRANSPORTATION_TYPE,
  TRANSPORT_TYPE_ASSESSMENT,
  TYPE_OF_REHAB,
  VISUALLY_IMPAIRED_DOCUMENT,
  WEBSOCKET_STATUS,
  WEEKDAYS,
  YES_NO_FIELD_OPTIONS,
} from "core/consts";
import { ALLOWED_EXTENSIONS_HIS } from "core/model/files/config";
import { ICDReason, SiteIdNumber } from "core/schemas/shared";
import { LucideProps } from "lucide-react";
import React, { ForwardRefExoticComponent, RefAttributes } from "react";
import type { Hit } from "react-instantsearch-core";
import { To } from "react-router-dom";
import { TrackingProp } from "react-tracking";
import { Locale } from "translations";

export type SideLocalization =
  (typeof SIDE_LOCALIZATION)[keyof typeof SIDE_LOCALIZATION];
// #TODO: fix - move translations usage out of core or introduce a core-safe abstraction so this import is not needed

import Translations from "translations/types";
import { IssueData } from "zod";
import {
  ALGOLIA_ANALYTICS_NAMES,
  ALL_MESSENGER_TABS,
  APP_KIND,
  APP_VERSION_NAMES,
  CANDIDATES_STATUS,
  CAPACITY_DECLINE_MODE,
  CAPACITY_STATUSES,
  CAREPROVIDER_DASHBOARD_TAB,
  CAREPROVIDER_TAB_TYPE_ATTRIBUTED,
  CAREPROVIDER_TAB_TYPE_IN_PROGRESS,
  CAREPROVIDER_TAB_TYPE_NEW,
  CAREPROVIDER_TAB_TYPE_OTHER,
  CARESEEKER_TAB_TYPE_ARCHIVED,
  CARESEEKER_TAB_TYPE_DRAFT,
  CARESEEKER_TAB_TYPE_FINISHED,
  CARESEEKER_TAB_TYPE_PATIENTS,
  CARE_FREQUENCY,
  CLINIC_TODO_DASHBOARD_TAB,
  COST_PAYER_TYPES,
  CURRENT_CARE_BASE_TYPES,
  CURRENT_CARE_FACILITY_TYPES,
  DISABLED_SEARCH_ACTION_TYPES,
  EXTENSIONS,
  MENTAL_ABILITY,
  MOBILITY,
  NO_CAPACITY_FOR_CARELEVEL,
  NO_CAPACITY_FOR_GENDER,
  NO_CAPACITY_FOR_INFECTION,
  NO_CAPACITY_FOR_ROOM,
  NO_CAPACITY_FOR_SERVICE,
  NO_CAPACITY_FOR_SOLUTION,
  NO_CAPACITY_FOR_SPECIALIZATION,
  QUERY_PROGRESS_TYPES,
  RECEIVER_DASHBOARD_FILTERS,
  REFERRAL_SOURCE,
  REHABILITATION_PAYMENT_OPTIONS,
  RELATIONSHIP_TO_PATIENT,
  REQUEST_ACTION_TYPES,
  REQUEST_ACTION_UNDO_TYPES,
  REQUEST_CONTEXT_DISABLED_TYPES,
  SEALD_FLOWS,
  SEARCH_ACTIONS,
  SEARCH_ACTION_VARIANTS,
  SEARCH_MERGE_STOP_SEARCH_PANELS,
  SEARCH_REASON,
  SENDER_DASHBOARD_FILTERS,
  VISIT_TIME,
} from "./consts";
import { CONSULTANT_EVENTS, EVENTS } from "./consts/events";
import { AG_UI_TRANSCRIPT_DECORATION } from "./model/agUi/serverToolInteraction";
import { OntologyType } from "./model/utils/ontologies";

export type { Recipients } from "@seald-io/sdk/lib/main";

export type TrackEventFn<P = unknown> = TrackingProp<P>["trackEvent"];

export type ValueOf<T> = T[keyof T];

export type NonNullableObj<T> = {
  [K in keyof T]-?: NonNullable<T[K]>;
};

export type Falsy = null | undefined | false | 0 | -0 | 0n | "";
export type Truthy<T> = T extends Falsy ? never : T;

export type NullableObj<T> = { [K in keyof T]: T[K] | null };
export type DeepNullableObj<T> = {
  [K in keyof T]: DeepNullableObj<T[K]> | T[K] | null;
};
export type DeepPartial<T> = {
  [K in keyof T]?: DeepPartial<T[K]> | T[K] | undefined;
};

/**
 * Like DeepPartial but allows null for any value (matches API response shapes).
 * Distributive conditional so union types (e.g. X | undefined) recurse into the object part.
 */
type AddNullRec<T> = T extends (..._args: never[]) => unknown
  ? T
  : T extends object & {}
  ? DeepPartialNullable<T> | null
  : T | null;
export type DeepPartialNullable<T> = { [K in keyof T]?: AddNullRec<T[K]> };

export type NullToUndefinedDeep<T> = T extends (...args: any[]) => any
  ? T
  : T extends null
  ? undefined
  : T extends Array<infer U>
  ? Array<NullToUndefinedDeep<U>>
  : T extends object
  ? { [K in keyof T]: NullToUndefinedDeep<T[K]> }
  : T;

type DistributiveValues<T extends Record<string, any>> = T extends T
  ? T[keyof T]
  : never;

export type InnerValues<
  T extends Record<keyof T, object>,
  K extends keyof T,
> = DistributiveValues<T[K]>;

export type EitherOr<T, U, Base = object> =
  | (Base & T & Partial<Record<keyof U, never>>)
  | (Base & U & Partial<Record<keyof T, never>>);

export type OmitRef<T> = Omit<T, "ref">;

export type ExactKeys<T, U extends keyof T> = Exclude<U, keyof T> extends never
  ? true
  : never;

export type Backend = (typeof BACKEND)[keyof typeof BACKEND];

type ValidationInfo = {
  infos: Record<string, any> | string | boolean | undefined;
};

export type ApolloCacheData = Record<string, any>;

export type Validation = ValidationInfo | boolean;

export type Country = typeof COUNTRY_DE;
export type SupportedLanguage = "de" | "en";

export type ExternalLinkType = "email" | "website" | "pdf" | "phone";

export type QueryProgress = (typeof QUERY_PROGRESS_TYPES)[number];
export type QueryProgressActive = Exclude<QueryProgress, "succeed" | "failed">;

export type InputWidthType =
  | "CHECKBOX"
  | "FULL_WIDTH"
  | "ISLAND"
  | "NESTED_CHECKBOX"
  | "SMALL"
  | "VERY_SMALL";

export type GeneratedFormsType =
  | "mobile-short"
  | "transport-info"
  | "transport-search";

export type AssessmentVariantType = ValueOf<typeof ASSESSMENT_VARIANTS>;

export type SortOrder = "asc" | "desc";

export type WithId = { id: string | number };

export type IconType = ForwardRefExoticComponent<
  Omit<LucideProps, "ref"> & RefAttributes<SVGSVGElement>
>;

export type TabConfigType<
  Tab extends GenericDashboardTab,
  TabKey extends GenericDashboardTabKey,
> = {
  Icon?: React.ComponentType<any> | null | undefined;
  archived?: boolean;
  key: Tab;
  title: string;
  tour?: TourElement;
  value: TabKey;
};

export type RequestCount = {
  count: number;
  hash?: string;
  new: number;
};

export type CareproviderDashboardCounts = Record<CareproviderTab, RequestCount>;
export type ClinicDashboardCounts = Record<CareseekerTab, RequestCount>;

export type Counts = Partial<
  CareproviderDashboardCounts & ClinicDashboardCounts
>;

export type CareproviderMetrics = {
  accept_count?: number;
  attributed_count?: number;
  avg_time_to_click?: number;
  avg_time_to_open?: number;
  avg_time_to_response?: number;
  local_accept_count?: number;
  local_attributed_count?: number;
  local_maybe_count?: number;
  local_request_count?: number;
  local_response_count?: number;
  maybe_count?: number;
  request_count?: number;
  response_count?: number;
};

export type OauthAuthenticationInput = {
  code: string;
  code_verifier: string;
  redirect_uri: string;
};

export type Contact = {
  academic_title?: number | null | undefined;
  email?: string;
  first_name?: string;
  gender?: number;
  landline_number?: string;
  last_name?: string;
  mobile_number?: string;
  position?: string;
  salutation?: number;
  send_emails?: boolean;
  title?: number | null | undefined;
};

export type Address = {
  __typename?: string;
  address?: string;
  city?: string;
  country?: string;
  latitude?: number;
  longitude?: number;
  street?: string;
  street_number?: string;
  zipcode?: string;
  federal_state?: string;
};

type CompanyStationAddress = Pick<Address, "address" | "city" | "zipcode">;

export type CareproviderAddress = Omit<Address, "zipcode"> & {
  federal_state?: string;
  zip_code?: string;
};

export type CompanyAddress = Omit<Address, "street" | "street_number">;

export type Location = Omit<Address, "address" | "street_number"> & {
  encrypted_house_number?: EncryptedField;
  federal_state?: string;
  floor?: string;
  radius_in_meter?: number;
};

export type CompanyStation = {
  address?: CompanyStationAddress;
  central_email?: string;
  central_phone_number?: string;
  corona_service_helper?: boolean;
  facilities?: Array<number>;
  fax_number?: string;
  id: number;
  is_complete: boolean;
  name?: string;
  other_remarks?: string;
  profile?: {
    accepted_age?: Interval;
    accepted_weight?: Interval;
    radius_in_meter?: number;
    room_types?: Array<number>;
  };
  services?: Array<number>;
  website?: string;
};

export type Stations = {
  [key: string]: CompanyStation;
};

export type TeamMember = {
  academic_title?: number;
  accessible_stations?: Array<number>;
  careprovider_roles?: boolean;
  email?: string;
  email_requests?: boolean;
  first_name?: string;
  id: string;
  is_complete: boolean;
  last_name?: string;
  mobile_phone?: string;
  phone?: string;
  position?: string;
  salutation?: number;
  status?: number;
  title?: number;
};

export type TeamMembers = {
  [key: string]: TeamMember;
};

export type OnboardingBlob = {
  all_process_completed?: boolean;
  stations: Stations;
  team_members: TeamMembers;
};

export type IkNumberDetail = {
  ik_number: number;
  is_main: boolean;
};

export type Company = {
  __typename?: string;
  address?: CompanyAddress;
  careproviders?: Array<Careprovider>;
  careseekers?: Array<Careseeker>;
  companies?: Array<Company>;
  company_type?: number;
  force_id?: string;
  id: number;
  ik_numbers?: Array<number>;
  ik_numbers_details?: Array<IkNumberDetail>;
  name: string;
  number_of_beds?: number;
  onboarding_blob?: OnboardingBlob;
  parent_company?: Company;
  parent_company_id?: number | null;
  send_to_company_first?: boolean;
  status?: number;
};

export type CostPayerType = (typeof COST_PAYER_TYPES)[number];

export type InsuranceConfig = {
  __typename?: string;
  use_vzd_kim_address?: boolean | null;
};

export type Insurance = {
  __typename?: string;
  careseeker_id?: number;
  config?: InsuranceConfig;
  id: number;
  ik_number?: number;
  integration_platform?: number;
  is_active?: boolean;
  kim_address?: string;
  name: string;
  type?: number;
};

export type VzdDirectoryEntry = {
  mail: string;
  telematik_id: string;
  display_name: string;
  domain_id: string;
};

export type TermsAndConditions = {
  date?: number;
  version?: string;
};

export type Capacity = {
  available_date?: number | null;
  capacity_confirmed?: boolean;
  capacity_status?: CapacityStatus | null;
  decline_scope?: CapacityDeclineMode | null;
  has_capacity?: boolean;
  updated_at?: number | null;
};

export type NoCapacityInfo = {
  careprovider_id: number;
  expiration: number;
  id: number;
  no_capacity_reasons: Array<NoCapacityReason>;
};

export type CareproviderProfile = {
  accepted_age?: Interval;
  accepted_weight?: Interval;
  additional_costs?: string;
  cardiovascular_equipment?: Array<number>;
  caregiver_genders?: Array<number>;
  confessions?: Array<number>;
  digestive_endoscopy?: Array<number>;
  imagery?: Array<number>;
  languages?: Array<number>;
  opt_out_b2c?: boolean;
  other_technical_equipment?: Array<number>;
  privacy_url?: string;
  radius_in_meter?: number;
  room_types?: Array<number>;
  social_worker_on_site?: boolean;
  supported_health_insurance_types?: Array<number>;
  whitelisted_zipcodes?: Array<string>;
};

export type AdmissionsForm = {
  __typename: string;
  form_type: AdmissionsFormType;
  id: number;
  status: AdmissionFormStatus;
  uuid?: string;
};

export type CareproviderOnboardingStats = {
  active_since?: number;
  onboarding_source?: number;
};

export type CareproviderActivities = {
  invite_contacts_popup?: boolean;
};

export type SealdConfig = {
  seald_flow?: number;
  seald_notes?: string;
};

export type CareproviderConfig = {
  disable_seald?: boolean;
  seald_config?: SealdConfig;
  seald_only_encryption?: boolean;
};

export type EventLocation =
  | "acp"
  | "documentation"
  | "eligibility"
  | "lastevent"
  | "messenger";

export type Assignee = Pick<
  Account,
  "__typename" | "first_name" | "id" | "last_name"
>;

export type EncryptionContext = {
  __typename?: string;
  auction_request_id?: number;
  careprovider_id?: number;
  careseeker_id?: number;
  file_id?: number;
  id: number;
  patient_id?: number;
  seald_display_id: string;
  seald_id: string;
  seald_type: number;
  chat_id?: number;
};

export type SSOActivationConsent = {
  account?: Pick<Account, "id" | "first_name" | "last_name">;
  signed_at?: number;
};

type SSORoleMapping = Record<string, unknown>;

type SSOConfig = {
  role_mappings?: SSORoleMapping[] | null;
  authorization_endpoint?: string;
  client_id?: string;
  client_secret?: string;
  deactivate_consent_flow?: boolean | null;
  idp_logout_url?: string;
  issuer?: string;
  token_endpoint?: string;
  userinfo_endpoint?: string;
};

export type SSOIntegration = {
  active: boolean;
  careseeker_id: number;
  consent?: SSOActivationConsent;
  created_at: string;
  email_domain: string;
  id: number;
  identity_provider_id: string;
  type: number;
  updated_at: string;
  config?: SSOConfig;
};

export type ReceiverDocsApiPublicKeys = Array<{
  id: number;
  public_key: string;
}>;

export type SealdAccessPayload = {
  account_id?: number;
  careprovider_id?: number;
  careseeker_id?: number;
  encrypt_for_self?: boolean;
  seald_id: string;
};

export type PendingSealdAccess = {
  account_id?: number;
  careprovider_id?: number;
  careseeker_id?: number;
  created_at: string;
  id: number;
  seald_encryption_context: EncryptionContext;
};

export type Extension = {
  __typename: "Extension";
  active_since: number | null;
  connected: boolean;
  integration_id: number;
  integration_type: keyof typeof EXTENSIONS;
};

export type ProviderSearchInfo = {
  eligible?: boolean;
  state?: ProviderSearch;
};

export type Careprovider = {
  __typename: string;
  accounts?: Array<Account> | null;
  activities?: CareproviderActivities;
  address?: CareproviderAddress;
  admission_forms?: AdmissionsForm[];
  assignee?: Account | null;
  capacity?: Capacity;
  care_provider_profile?: CareproviderProfile;
  central_email?: string;
  central_phone_number?: string;
  company?: Company | null;
  config?: CareproviderConfig;
  contacts?: Array<Contact>;
  data_processing_agreement?: CareproviderDpaFile;
  distance?: string;
  duplicated_from?: Careprovider;
  email_requests?: boolean;
  email_summary?: boolean;
  events?: Array<Event>;
  extensions?: Extension[];
  facilities?: Array<number>;
  fax_number?: string;
  feedback?: string;
  files?: CareproviderFiles;
  id: number;
  inactive_reason?: number;
  lead_id?: string;
  metrics?: CareproviderMetrics;
  name?: string;
  new?: boolean;
  no_capacities?: Array<NoCapacityInfo>;
  onboarding?: CareproviderOnboarding;
  onboarding_stats?: CareproviderOnboardingStats;
  opportunity_id?: string;
  other_remarks?: string;
  patient_type?: SearchType;
  pending_messages?: number;
  ppm_receiver_id?: number;
  prerequisites?: Array<number>;
  product_features?: ProductFeature[];
  profile?: CareproviderProfile;
  provider_search_info?: ProviderSearchInfo;
  receive_fax?: boolean;
  receive_sms?: boolean;
  related_careseekers?: Array<RelatedCareseeker>;
  seald_encryption_context?: EncryptionContext;
  services?: Array<number>;
  specializations?: Specializations;
  status?: CareproviderStatus;
  terms_and_conditions?: TermsAndConditions;
  thumbnail_url?: string;
  token?: string;
  trigger_ppm_self_onboarding?: boolean;
  website?: string;
};

export type StopReason = {
  hideInForm?: boolean;
  id: string;
  label: React.JSX.Element | string;
  value: number;
};

export type WoundCare = {
  description?: string;
};

export type PsychiatricCare = {
  description?: string;
};

export type IntegrationAssistance = {
  description?: string;
};

export type PsychiatricHomeNursing = {
  description?: string;
};

export type SubstituteOffers = {
  description?: string;
};

export type Sociotherapy = {
  description?: string;
};

export type DailyActivities = {
  description?: string;
};

export type PsychProtectedArea = {
  description?: string;
};

export type PsychClosedArea = {
  description?: string;
};

export type Companionship = {
  companionship_grant?: boolean;
  description?: string;
};

export type Breathing = {
  oxygen_therapy?: string;
  specialised_intensive_nurse?: boolean;
  tracheostomy?: string;
};

export type Dialysis = {
  hemodialysis?: string;
  peritoneal_dialysis?: string;
};

export type BaseCare = {
  __typename?: string;
  companionship_grant?: boolean;
  description?: string;
};

export type HelpAtHome = {
  description?: string;
};

export type CompressionCare = {
  description?: string;
};

export type Medication = {
  blood_thinner?: string;
  description?: string;
};

export type Food = {
  dysphagia?: string;
  enteral_nutrition?: string;
  food_help?: Array<number>;
  meals?: Array<number>;
  parenteral_nutrition?: string;
};

export type IncontinenceHelp = {
  fecal_incontinence?: string;
  incontinence_help_type?: number;
  requires_material_supplies?: boolean;
  urinary_incontinence?: string;
};

export type Injection = {
  description?: string;
};

export type PatientNeedSupport = {
  body_care?: boolean;
  dressing?: boolean;
  eating?: boolean;
};

export type PatientNeedMonitoring = {
  circulation?: string;
  metabolism?: string;
  respiration?: string;
};

export type AccessDrainages = {
  central_venous_catheter?: string;
  drainage?: string;
  gastric_tube?: string;
  intravenous_injection?: string;
  other_access_drainages?: string;
  peripheral_venous_catheter?: string;
  permanent_catheter?: string;
  suprapubic_catheter?: string;
  tracheal_cannula?: string;
  urinary_catheter?: string;
};

export type PatientNeeds = {
  __typename?: string;
  access_drainages?: AccessDrainages;
  base_care?: BaseCare;
  basic_medical_care?: { description?: string };
  breathing?: Breathing;
  companionship?: Companionship;
  compression?: CompressionCare;
  dialysis?: Dialysis;
  food?: Food;
  help_at_home?: HelpAtHome;
  important_information?: string | null | undefined;
  incontinence?: IncontinenceHelp;
  injection?: Injection;
  medication?: Medication;
  monitoring?: PatientNeedMonitoring;
  need_for_assistance_description?: string | null;
  nutrition?: Food;
  oxygen_therapy?: string;
  palliative?: Palliative;
  psychiatric_care?: PsychiatricCare;
  integration_assistance?: IntegrationAssistance;
  psychiatric_home_nursing?: PsychiatricHomeNursing;
  substitute_offers?: SubstituteOffers;
  sociotherapy?: Sociotherapy;
  daily_activities?: DailyActivities;
  psych_protected_area?: PsychProtectedArea;
  psych_closed_area?: PsychClosedArea;
  remarks?: string;
  static_care_disabled_patients?: { description?: string };
  support?: PatientNeedSupport;
  wound_care?: WoundCare;
  care_for_children_and_teenagers?: CareForChildrenAndTeenagers;
  care_for_youth?: CareForYouth;
};

export type SingerAssessment = {
  __typename?: string;
  date?: number;
  form?: {
    __typename?: string;
    concentration: number;
    domestic_life_household: number;
    dressing_and_undressing: number;
    food: number;
    hygiene: number;
    listening: number;
    orientation: number;
    planning: number;
    reading: number;
    shower: number;
    social_interaction: number;
    stairs: number;
    stool: number;
    talking: number;
    toilet_use: number;
    transfer: number;
    urination: number;
    walking: number;
    wheelchair: number;
    writing: number;
  };
  score?: number;
};

export type DependencyDiagnosis = {
  __typename?: string;
  agitated?: PredicamentYesNoUnknown | number;
  agitated_description?: string;
  barthel_assessment?: BarthelAssessment;
  dependency_level?: number;
  early_rehab_assessment?: EarlyRehabAssessment;
  has_help_at_home?: PredicamentYesNoUnknown | number;
  requires_support_with_feeding?: PredicamentYesNoUnknown | number;
  requires_walking_aid?: PredicamentYesNoUnknown | number;
  returning_home_short_term?: PredicamentYesNoUnknown | number;
  singer_assessment?: SingerAssessment;
};

export type InfectionAndGerms = {
  __typename?: string;
  clostridien?: boolean;
  description?: string;
  four_mrgn?: boolean;
  hepatitis_c?: boolean;
  mrsa?: boolean;
  other?: string;
  remarks?: string;
  requires_isolation?: boolean;
  three_mrgn?: boolean;
  vre?: boolean;
};

export type HospitalStay = {
  __typename?: string;
  complications?: string;
  doctor_in_charge_in_hospital?: string;
  doctor_in_charge_in_hospital_phone?: string;
  geriatric_early_stage?: string;
  operation_date?: number;
  operation_description?: string;
  therapy_at_hospital?: string;
};

export type LimitedCapacity = {
  limited_cognitive_capacity: string | null | undefined;
  limited_physical_capacity: string | null | undefined;
  limited_psychological_capacity: string | null | undefined;
  limited_social_behaviour: string | null | undefined;
  other: string | null | undefined;
};

export type RehabilitationPotential = {
  description?: string;
  evaluation?: number;
};

export type PhysicalDisabilities = {
  assistive_equipment?: string;
  auditive_impairment?: string;
  existing_medical_supplies?: string;
  load_carrying_ability?: string;
  mobility?: number;
  mobility_additional_information?: string;
  orthese?: string;
  prescribed_medical_supplies?: string;
  prothese?: string;
  required_medical_supplies?: string;
  visual_impairment?: string;
};

export type CarePreferences = {
  __typename?: string;
  accompanying_person?: boolean;
  accompanying_person_description?: string;
  barrier_free_room?: boolean;
  room_type?: number;
  specialist_doctor?: boolean;
};

export type Solution = (typeof SOLUTIONS)[number];
export type Solutions = Array<Solution>;
export type Specialization = number;
export type Specializations = Array<Specialization>;

export type Winner = {
  auction_request?: AuctionRequest;
  auction_request_id?: number;
  careprovider?: Careprovider;
  careprovider_name?: string;
  created_at?: number;
  external_provider?: boolean;
  found_by?: number;
  solution?: Solution;
  specialization?: Specialization;
  unknown_provider?: boolean;
  updated_at?: number;
};

export type CancelAuction = {
  description?: string;
  reason?: number;
};

export type PickUpTime = {
  hour: number;
  minute: number;
};

export type PickUpTimes = {
  end: PickUpTime;
  start: PickUpTime;
};

export type MonitoringNeeds = {
  ecg: boolean;
  pulse_oximeter: boolean;
};

export type AuctionProfile = {
  __typename?: string;
  has_transitional_care?: boolean;
  is_elective?: boolean;
  is_visually_impaired?: number;
  monitoring_needs?: MonitoringNeeds;
  needs_oxygen?: number;
  no_site_support_required?: boolean | null | undefined;
  patient_type_updated?: boolean;
  pick_up?: PickUpTimes;
  search_destination?: Location;
  search_location?: Location;
};

export type SearchActionType = (typeof SEARCH_ACTIONS)[number];
export type DisabledSearchActionType =
  (typeof DISABLED_SEARCH_ACTION_TYPES)[number];
export type SearchActionVariantType = (typeof SEARCH_ACTION_VARIANTS)[number];

export type SearchAction = {
  __typename?: string;
  action_type: SearchActionType;
  context?: {
    __typename?: string;
    disabled?: DisabledSearchActionType | null;
    variant?: SearchActionVariantType | null;
    values?: number[];
  } | null;
};

export type SearchActions = SearchAction[];

type FrontEndOnlyActions = typeof SEARCH_ACTION_DISPLAY_FILES_TAB;

export type SearchActionsWithHandlers = Exclude<
  SearchActionType,
  FrontEndOnlyActions
>;

export type PatientActionType = ValueOf<typeof PATIENT_ACTION>;

export type SchemaVersion = ValueOf<typeof SCHEMA_VERSION>;

export type AuctionForm = {
  id?: number;
  metadata?: FormMetadata<DocsFormName>;
  form_data?: EncryptedField | null;
  updated_at?: number;
  created_at?: number;
  form_type?: RecareFileType;
  last_event_id?: number;
  last_event?: Event;
};

export type Auction = {
  __typename: string;
  forms?: AuctionForm[];
  action_required_by_user?: boolean;
  admissions?: Admissions;
  all_contacted?: boolean;
  all_negative?: boolean;
  assessment_completed?: boolean;
  assessment_variant?: AssessmentVariantType;
  cancel_auction?: CancelAuction;
  cancel_validation_reason?: string;
  candidates_status?: CandidatesStatus;
  country_wide_search?: boolean;
  created_at?: number;
  id: number;
  is_stale?: boolean;
  last_status_change?: number;
  max_accepts?: boolean;
  medical_supplies?: MedicalSupplies;
  new_responses?: number;
  patient: Patient;
  patient_id?: number;
  payers?: Payers;
  pending_requests?: number;
  profile?: AuctionProfile;
  radius_in_meter?: number;
  request_count?: number;
  requests?: Array<AuctionRequest>;
  seald_encryption_context?: EncryptionContext;
  search_actions?: SearchActions;
  search_type: SearchType;
  seen_by_user?: boolean;
  services?: Array<number>;
  session_key_context?: SessionKeyContext;
  share_patient_data_automatically?: boolean;
  solutions?: Solutions;
  specializations?: Array<Specialization>;
  start_date?: number;
  start_date_flexible?: boolean;
  status?: number;
  winner?: Winner;
};

export type WarningsPayload = {
  auction_request?: AuctionRequest;
  careprovider: Careprovider;
  solution_filter_reasons: SolutionFilterReasons;
};

/** Widen every value of a generated payload to allow the legacy `null`s. */
export type NullableValues<TPayload> = {
  [Key in keyof TPayload]?: TPayload[Key] | null;
};

export type AuctionNoPatient = Omit<Auction, "patient">;

export type AccountRole = (typeof ACCOUNT_ROLES)[number];

export type CareseekerMinimal = Pick<
  Careseeker,
  | "__typename"
  | "address"
  | "id"
  | "name"
  | "patient_types"
  | "product_features"
  | "status"
  | "type"
> & { config: Pick<CareseekerConfig, "activate_ahb_approver"> };

export type CareseekerRole = {
  careseeker?: CareseekerMinimal;
  id?: number;
  roles?: AccountRole[];
};

export type CareproviderInRole = Pick<
  Careprovider,
  "address" | "id" | "name" | "product_features" | "status"
>;

export type CareproviderRole = {
  careprovider?: CareproviderInRole;
  id?: number;
  roles?: AccountRole[];
};

export type Roles = {
  admin_roles?: number[];
  careprovider_roles?: Array<CareproviderRole>;
  careseeker_roles?: Array<CareseekerRole>;
};

export type Activity = {
  updated_at?: number;
};

export type Activities = {
  add_members_cta?: Activity;
};

export type Rating = {
  score: number;
  timestamp: number;
};

export type CareseekerActions = {
  create_patients: boolean;
  show_drafts: boolean;
};

export type SealdEncryptionAccessStatus =
  (typeof SEALD_ENCRYPTION_ACCESS_STATUS)[number];

export type AccountType = ValueOf<typeof ACCOUNT_TYPE>;

export type AccountMutationArgs = Omit<
  NullableObj<Account>,
  "id" | "__typename"
>;

export type Account = {
  __typename: string;
  academic_title?: number;
  accessible_stations?: Array<number>;
  account_type?: AccountType;
  action?: {
    context?: {
      careprovider_id?: number;
      careseeker_id?: number;
    };
    type: number;
    version?: string;
  };
  activities?: Activities;
  browser_notifications_disabled?: boolean;
  careprovider_roles?: boolean;
  created_at?: number;
  crypto_keys?: RCryptoKey;
  email?: string;
  email_requests?: boolean;
  email_summary?: boolean;
  events?: Array<Event>;
  experiments?: Array<ExperimentAttribution>;
  fax_number?: string;
  first_login?: number;
  first_name?: string;
  gender?: number;
  id: number;
  intercom_id?: string;
  is_complete?: boolean;
  last_login?: number;
  last_name?: string;
  last_password_change?: number;
  mobile_devices?: Array<{
    account_id: number;
    device_token?: string;
    id: string;
    type: string;
  }>;
  mobile_phone?: string;
  notes?: string;
  phone?: string;
  position?: string;
  public_key?: string;
  ratings?: Array<Rating>;
  receive_sms?: boolean;
  roles?: Roles;
  salutation?: number;
  seald_database_key?: string;
  seald_encryption_status?: SealdEncryptionAccessStatus;
  seald_registered?: boolean;
  seald_test_identity?: string;
  seald_two_man_rule_key?: string;
  seald_user_license_token?: string;
  sso_active?: boolean;
  sso_user_id?: string;
  status?: number;
  title?: number;
};

export type AccountInIdentification = Pick<
  Account,
  | "__typename"
  | "account_type"
  | "email"
  | "first_name"
  | "id"
  | "last_name"
  | "phone"
>;

export type CareseekerConfig = {
  __typename?: string;
  activate_ahb_approver?: boolean;
  activate_docs_redesign?: boolean;
  activate_dta?: boolean;
  activate_gateway_debug_mode?: boolean;
  activate_parallel_search?: boolean;
  activate_predict?: boolean;
  activate_search_merge?: boolean;
  activate_ssl_hl7_connector?: boolean;
  auto_validate?: boolean;
  deactivate_received_files?: boolean;
  disable_seald?: boolean;
  filter_on_social_worker?: boolean;
  ip_range?: string;
  jwt_expiration_in_minutes?: number;
  on_premise_archive_integration_enabled?: boolean;
  on_premise_authorization_token?: string;
  kim_enabled?: boolean;
  on_premise_domain_ssl?: string;
  on_premise_file_sync?: boolean;
  seald_config?: SealdConfig;
  seald_only_encryption?: boolean;
  use_kis_integration?: boolean;
  use_vzd_kim_address?: boolean;
  whitelisted_email_domains?: Array<string>;
  whitelisted_home_care_specializations?: Array<number>;
  whitelisted_hospital_specializations?: Array<number>;
  whitelisted_reha_specializations?: Array<number>;
};

export type CareseekerModule = {
  __typename?: string;
  onboarding_email_link?: string;
  onboarding_radius_km?: number;
  onboarding_requirements?: string;
  prio_list_activation_target?: number;
  start_date?: number;
  status: number;
};

export type ProductFeatureConfigRequirement = {
  configPath: string;
  label: string;
  isActive: boolean;
};

export type ProductFeatureConfigRequirements = {
  [key in ProductFeatureType]?: ProductFeatureConfigRequirement[];
};

export type OnpremiseConfigInput = Pick<
  OnpremiseConfig,
  | "activate_gateway_debug_mode"
  | "config"
  | "name"
  | "on_premise_domain_ssl"
  | "on_premise_domain"
  | "on_premise_file_sync"
  | "on_premise_archive_integration_enabled"
  | "should_restart"
  | "token"
  | "predict_action"
  | "kim_enabled"
>;

export type AccountRoleStationInput = {
  account_id: number;
  careprovider_id?: number;
  careseeker_id?: number;
  role_value: number;
  station_ids: number[];
};

export type AccountRoleAssignment = {
  file_types: RecareFileType[];
  role_value: AccountRole;
};

export enum OnpremFieldStatus {
  Empty = "empty",
  Fail = "fail",
  Imported = "imported",
}

export enum OnpremImportStatus {
  NotFound = "notfound",
  Success = "success",
}

export type OnPremImport = {
  account_id: number | undefined;
  admit_date_time: OnpremFieldStatus;
  allergies: OnpremFieldStatus;
  anamnesis: OnpremFieldStatus;
  attending_doctor: OnpremFieldStatus;
  barthel_assessment: OnpremFieldStatus;
  birth_date: OnpremFieldStatus;
  care_level: OnpremFieldStatus;
  careseeker_id: number;
  consulting_doctor: OnpremFieldStatus;
  created_at?: number;
  discharge_date_time: OnpremFieldStatus;
  early_rehab_assessment: OnpremFieldStatus;
  evolution: OnpremFieldStatus;
  external_id: string;
  first_name: OnpremFieldStatus;
  gender: OnpremFieldStatus;
  guardians: OnpremFieldStatus;
  height: OnpremFieldStatus;
  id?: number;
  import_status: OnpremImportStatus;
  infections: OnpremFieldStatus;
  insurance_name: OnpremFieldStatus;
  insurance_number: OnpremFieldStatus;
  last_name: OnpremFieldStatus;
  main_diagnoses: OnpremFieldStatus;
  medical_history: OnpremFieldStatus;
  medical_instructions: OnpremFieldStatus;
  patient_address: OnpremFieldStatus;
  patient_city: OnpremFieldStatus;
  patient_postal_code: OnpremFieldStatus;
  recommended_routine: OnpremFieldStatus;
  relatives: OnpremFieldStatus;
  secondary_diagnoses: OnpremFieldStatus;
  singer_assessment: OnpremFieldStatus;
  station: OnpremFieldStatus;
  weight: OnpremFieldStatus;
};

export type OnpremiseConfig = {
  __typename: "OnpremiseConfig";
  activate_gateway_debug_mode?: boolean;
  activate_ssl_hl7_connector?: boolean;
  careseekers?: Careseeker[];
  config?: Record<string, any> & {
    __typename: "Config";
    clinical_notes_settings?: { ORUEnabled?: boolean };
    field_mapping?: Record<string, any>;
    vital_signs_settings?: { ORUEnabled?: boolean };
  };
  hl7_version?: "hl7_2" | "fhir";
  id: number | null;
  name?: string;
  on_premise_archive_integration_enabled?: boolean;
  on_premise_authorization_token?: string;
  on_premise_domain?: string;
  on_premise_domain_ssl?: string;
  on_premise_file_sync?: boolean;
  predict_action?: {
    __typename: "PredictAction";
    context?: Record<string, any>;
    type: number;
  };
  should_restart?: boolean;
  token?: string;
  kim_enabled?: boolean;
};

export enum CareseekerModuleName {
  care = "care",
  hospital = "hospital",
  medical_supplies = "medical_supplies",
  psych_care = "psych_care",
  reha = "reha",
  transport = "transport",
}

export type CareseekerModules = {
  __typename?: string;
  [CareseekerModuleName.care]: CareseekerModule;
  [CareseekerModuleName.hospital]: CareseekerModule;
  [CareseekerModuleName.medical_supplies]: CareseekerModule;
  [CareseekerModuleName.psych_care]: CareseekerModule;
  [CareseekerModuleName.reha]: CareseekerModule;
  [CareseekerModuleName.transport]: CareseekerModule;
};

export type Careseeker = {
  __typename: string;
  accounts?: Array<Account>;
  activate_on_premise?: boolean | null;
  address?: Address;
  banking_details?: BankingDetails;
  central_email?: string;
  code?: string;
  company?: Company;
  company_id?: number;
  config?: CareseekerConfig;
  contact_name?: string;
  contact_phone?: string;
  contacts?: any;
  created_at?: number;
  events?: Array<Event>;
  external_id?: string;
  force_id?: string;
  id: number;
  intercom_id?: string;
  kim_address?: string;
  modules?: CareseekerModules;
  name?: string;
  notes?: string;
  number_of_beds?: number;
  on_premise_config?: OnpremiseConfig;
  on_premise_config_id?: number | null;
  patient_types?: Array<SearchType>;
  ppm_sender_id?: number;
  priority_providers?: Array<Careprovider>;
  product_features?: ProductFeature[];
  seald_encryption_context?: EncryptionContext;
  sender_user_management_file?: SenderUserManagementFile;
  site_id_number?: SiteIdNumber;
  sso_integration?: SSOIntegration;
  start_date?: number;
  stations?: Array<string>;
  stations_full?: Array<Station>;
  status?: number;
  type?: CareseekerType;
  updated_at?: number;
};

export type BankingDetails = {
  __typename?: string;
  bank_name?: string;
  iban?: string;
  ik_number?: string;
};

export type SocialWorker = Account;

export type GrantStatus = (typeof GRANT_STATUSES)[number];
export type ShortTermGrantStatus = (typeof SHORT_TERM_GRANT_STATUSES)[number];

export type CareseekerPatientInfo = {
  careseeker_patient_info: {
    careseeker: Careseeker;
    has_patients: boolean;
  }[];
};

export type GuardianData = {
  __typename?: string;
  city?: EncryptedField | null;
  first_name?: EncryptedField | null;
  house_number?: EncryptedField | null;
  last_name?: EncryptedField | null;
  phone?: EncryptedField | null;
  responsibilities?: EncryptedField | null;
  street?: EncryptedField | null;
  type?: Guardian | null;
  zipcode?: EncryptedField | null;
};

export type RelativeData = {
  __typename?: string;
  city?: EncryptedField | null;
  first_name?: EncryptedField | null;
  house_number?: EncryptedField | null;
  last_name?: EncryptedField | null;
  phone?: EncryptedField | null;
  street?: EncryptedField | null;
  relationship?: EncryptedField | null;
  relationship_other?: EncryptedField | null;
  zipcode?: EncryptedField | null;
};

export type PatientCommunication = {
  __typename?: string;
  decisions_and_language?: string | null;
  guardian_contact_information?: EncryptedField | null;
  guardian_requested?: boolean;
  guardians?: GuardianData[];
  has_guardian?: boolean;
  patient_cannot_communicate_in_german?: boolean;
  patient_is_contact?: boolean;
  patient_is_contact_description?: EncryptedField | null;
  patient_language?: string;
  patient_uses_sign_language?: string;
  relatives?: RelativeData[];
  relatives_available?: boolean;
  relatives_description?: EncryptedField | null;
};

export type Financing = {
  __typename?: string;
  benefit_entitlement_group?: {
    available?: boolean | null;
    description?: string | null;
  };
  carelevel?: CareLevelInfos;
  insurance_additional_information?: string | null;
  insurance_status?: number | null;
  insurance?: Insurance;
  insurance_id?: number;
  insurance_number?: EncryptedField | null;
  more_information?: string;
  patient_has_health_insurance_state?: number;
  payout?: number;
  preventative_care?: GrantStatus;
  private_payment_bool?: boolean;
  public_care_insurance_status?: boolean;
  reimbursment_for_help_at_home?: GrantStatus;
  reimbursment_secured?: GrantStatus;
  relief_services?: number;
  short_term_care?: ShortTermGrantStatus;
  social_help_recipient_bool?: boolean;
};

export type HealthInsuranceStatus = ValueOf<typeof HEALTH_INSURANCE_STATUS>;

export type SelectedPaymentMethod =
  (typeof REHABILITATION_PAYMENT_OPTIONS)[number];

export type Payers = {
  __typename?: string;
  civil_servants_aid?: string;
  free_from_supplementary_payment_state?: number;
  further_information?: string;
  insurance?: Insurance;
  other_payer?: string;
  public_accident_insurance?: string;
  public_pension?: Insurance;
  selected_payment_method?: SelectedPaymentMethod;
  self_payer?: string;
  social_service_department?: string;
  supplementary_insurance?: string;
  supplementary_insurance_state?: PredicamentYesNoUnknown;
  supplementary_payment?: string;
  supplementary_payment_state?: PredicamentYesNoUnknown;
};

export type GeneralPractitioner = {
  __typename?: string;
  contact_details?: string;
  name?: string;
  first_name?: EncryptedField | null;
  last_name?: EncryptedField | null;
  honorific_prefix?: EncryptedField | null;
  honorific_suffix?: EncryptedField | null;
  general_practitioner?: EncryptedField | null;
  street?: EncryptedField | null;
  house_number?: EncryptedField | null;
  city?: EncryptedField | null;
  zipcode?: EncryptedField | null;
  phone?: EncryptedField | null;
  job_title?: EncryptedField | null;
};

export type Psychiatrist = {
  first_name?: EncryptedField | null;
  last_name?: EncryptedField | null;
  honorific_prefix?: EncryptedField | null;
  honorific_suffix?: EncryptedField | null;
  job_title?: EncryptedField | null;
  phone?: EncryptedField | null;
  street?: EncryptedField | null;
  house_number?: EncryptedField | null;
  city?: EncryptedField | null;
  zipcode?: EncryptedField | null;
};

export type LastAction = {
  account?: Pick<
    Account,
    "__typename" | "first_name" | "id" | "last_name"
  > | null;
  timestamp?: string | null;
};

export type PatientProfile = {
  __typename: string;
  admission_date?: number;
  age?: number | null;
  age_interval?: {
    __typename?: string;
    max: number | null;
    min: number | null;
  } | null;
  barrier_free?: PredicamentYesNoUnknown;
  barrier_free_description?: string;
  birth_date?: EncryptedField | null;
  care_duration_in_days?: number;
  communication?: PatientCommunication;
  direct_transfer_necessary?: boolean;
  discharge_date?: number;
  financing?: Financing;
  first_name?: EncryptedField | null;
  gender?: Gender;
  general_practitioner?: GeneralPractitioner;
  has_patient_consent?: boolean;
  psychiatrist?: Psychiatrist;
  height?: EncryptedField | null;
  height_interval?: { __typename?: string; min: number } | null;
  interested_long_term_stay?: boolean;
  last_name?: EncryptedField | null;
  lift_available_description?: string | null | undefined;
  lift_available_state?: PredicamentYesNoUnknown;
  living_situation?: LivingSituation;
  living_situation_other?: string;
  placement_order?: {
    status?: number | null;
    type?: number | null;
    exhibiting_state?: string | null;
  } | null;
  preferences?: CarePreferences;
  unsafe_current_domestic_situation?: string;
  unsafe_current_domestic_situation_state?: PredicamentYesNoUnknown | number;
  weight?: EncryptedField | null;
  weight_interval?: {
    __typename?: string;
    max: number | null;
    min: number | null;
  } | null;
};

export type RoomType = ValueOf<typeof ROOM_TYPES>;

export type DPAFile = {
  content?: string;
  file_name: string;
  file_type: number;
  version?: string;
};

export type SenderUserManagementFile = {
  account_id: number;
  careseeker_id: number;
  file_name: string;
  id: number;
};
export type GetUserManagmentFileParams = Pick<SenderUserManagementFile, "id">;
export type CreateUserManagmentFileParams = Omit<
  SenderUserManagementFile,
  "id"
> & {
  content: string;
};

export type Base64EncodedFile = string & { __brand: "Base64EncodedFile" };

export type AHBWithdrawFormValues = {
  withdraw_reason: ValueOf<typeof AHB_WITHDRAW_REASON>;
  withdraw_reason_other?: string;
};

export type AHBProcedureId = ValueOf<typeof AHB_PROCEDURE_ID>;
export type AHBMessageType = ValueOf<typeof AHB_MESSAGE_TYPE>;
export type AHBMessageStatus = ValueOf<typeof AHB_MESSAGE_STATUS>;
export type AHBProcessingCode = ValueOf<typeof AHB_PROCESSING_CODE>;

export type AHBMessage = {
  attached_file_count: number;
  created_at: number;
  external_id: string;
  message_id: string;
  receiver_kim: string;
  ref_message_id?: string;
  sender_kim: string;
  status?: AHBMessageStatus;
  type: AHBMessageType;
  updated_at: number;
  withdraw_reason_other?: string;
  withdraw_reason?: ValueOf<typeof AHB_WITHDRAW_REASON>;
};

export type AHBMessageResponse = {
  external_id: string;
  message_id: string;
  processed_at: number;
  received_at: number;
  receiver_kim: string;
  response_id: string;
  sender_kim: string;
  status: ValueOf<typeof AHB_RESPONSE_STATUS>;
  type?: typeof AHB_MESSAGE_TYPE.RESPONSE;
};

export type AHBMessagesPayload = {
  messages: AHBMessage[];
  responses: AHBMessageResponse[];
};

export type AHBMessageThread = {
  chain: AHBMessage[];
  message: AHBMessage;
};

export type GKVGeneralFormData = {
  case_id?: string | null;
  communication_in_german_possible?: PredicamentYesNo | null;
  communication_other_language?: string | null;
  data_transfer_consent_given?: PredicamentYesNo | null;
  // CheckboxGroup used instead of Checkbox to leverage HeroUI inbuilt errorMessage handling
  // so we need to use an array of PredicamentYes instead of a single PredicamentYes
  // declaration_of_intent_confirmed will only be an array in form state
  // when the form is submitted, it will be saved as a single PredicamentYes
  declaration_of_intent_confirmed?: PredicamentYes | PredicamentYes[] | null;
  domestic_situation_is_safe?: PredicamentYesNo | null;
  general_practitioner_name?: string | null;
  general_practitioner_contact_details?: string | null;
  general_practitioner_city?: string | null;
  general_practitioner_first_name?: string | null;
  general_practitioner_honorific_prefix?: string | null;
  general_practitioner_honorific_suffix?: string | null;
  general_practitioner_housenumber?: string | null;
  general_practitioner_job_title?: string | null;
  general_practitioner_last_name?: string | null;
  general_practitioner_phone_number?: string | null;
  general_practitioner_street?: string | null;
  general_practitioner_zipcode?: string | null;
  hospital_city?: string | null;
  hospital_house_number?: string | null;
  hospital_ik_number?: string | null;
  hospital_name?: string | null;
  hospital_postal_code?: string | null;
  hospital_street?: string | null;
  insurance_ik_number?: string | null;
  insurance_number?: string | null;
  insured_details_application_insurance_benefits?: PredicamentYesNo | null;
  insured_details_guardian_1_city?: string | null;
  insured_details_guardian_1_first_name?: string | null;
  insured_details_guardian_1_house_number?: string | null;
  insured_details_guardian_1_last_name?: string | null;
  insured_details_guardian_1_phone?: string | null;
  insured_details_guardian_1_street?: string | null;
  insured_details_guardian_1_type?: Guardian | null;
  insured_details_guardian_1_zipcode?: string | null;
  insured_details_guardian_2_city?: string | null;
  insured_details_guardian_2_first_name?: string | null;
  insured_details_guardian_2_house_number?: string | null;
  insured_details_guardian_2_last_name?: string | null;
  insured_details_guardian_2_phone?: string | null;
  insured_details_guardian_2_street?: string | null;
  insured_details_guardian_2_type?: Guardian | null;
  insured_details_guardian_2_zipcode?: string | null;
  living_lift?: PredicamentYesNo | null;
  living_lift_description?: string | null;
  living_situation?: HomeCareSituation | null;
  living_situation_at_home?: AtHomeSituation | null;
  living_special?: string | null;
  patient_birthdate?: number | null;
  patient_city?: string | null;
  patient_first_name?: string | null;
  patient_housenumber?: string | null;
  patient_last_name?: string | null;
  patient_phone_number?: string | null;
  patient_postfach?: string | null;
  patient_street?: string | null;
  patient_zipcode?: string | null;
  prefered_clinic_admission_possible?: string | null;
  prefered_clinic_city?: string | null;
  prefered_clinic_contacted?: PredicamentYesNo | null;
  prefered_clinic_contacted_start_date?: number | null;
  prefered_clinic_count?: number | null;
  prefered_clinic_house_number?: string | null;
  prefered_clinic_name?: string | null;
  prefered_clinic_phone?: string | null;
  prefered_clinic_postal_code?: string | null;
  prefered_clinic_street?: string | null;
  prefered_clinic_2_admission_possible?: string | null;
  prefered_clinic_2_city?: string | null;
  prefered_clinic_2_contacted_start_date?: number | null;
  prefered_clinic_2_house_number?: string | null;
  prefered_clinic_2_name?: string | null;
  prefered_clinic_2_phone?: string | null;
  prefered_clinic_2_postal_code?: string | null;
  prefered_clinic_2_street?: string | null;
  prefered_clinic_3_admission_possible?: string | null;
  prefered_clinic_3_city?: string | null;
  prefered_clinic_3_contacted_start_date?: number | null;
  prefered_clinic_3_house_number?: string | null;
  prefered_clinic_3_name?: string | null;
  prefered_clinic_3_phone?: string | null;
  prefered_clinic_3_postal_code?: string | null;
  prefered_clinic_3_street?: string | null;
  prefered_clinic_4_admission_possible?: string | null;
  prefered_clinic_4_city?: string | null;
  prefered_clinic_4_contacted_start_date?: number | null;
  prefered_clinic_4_house_number?: string | null;
  prefered_clinic_4_name?: string | null;
  prefered_clinic_4_phone?: string | null;
  prefered_clinic_4_postal_code?: string | null;
  prefered_clinic_4_street?: string | null;
  prefered_clinic_5_admission_possible?: string | null;
  prefered_clinic_5_city?: string | null;
  prefered_clinic_5_contacted_start_date?: number | null;
  prefered_clinic_5_house_number?: string | null;
  prefered_clinic_5_name?: string | null;
  prefered_clinic_5_phone?: string | null;
  prefered_clinic_5_postal_code?: string | null;
  prefered_clinic_5_street?: string | null;
  reason_for_reha_clinic?: string | null;
  retirement_earning_capacity_company?: string | null;
  retirement_pension_applied?: PredicamentYesNo | null;
  retirement_pension_company?: string | null;
  retirement_pension_earning_capacity_applied?: PredicamentYesNo | null;
  site_id_number?: SiteIdNumber | null;
  social_worker_fax_number?: string | null;
  social_worker_first_name?: string | null;
  social_worker_last_name?: string | null;
  social_worker_phone_number?: string | null;
};

export type GKVMedicalFormData = {
  admission_date?: number | null;
  complication_cause_cardiovascular?: boolean | null;
  complication_cause_cardiovascular_description?: string | null;
  complication_cause_maindiagnosis?: boolean | null;
  complication_cause_maindiagnosis_description?: string | null;
  complication_cause_other?: boolean | null;
  complication_cause_other_description?: string | null;
  complication_in_treatment_process?: PredicamentYesNo | null;
  discharge_date?: number | null;
  doctor_exam_date?: number | null;
  doctor_in_charge_in_hospital_first_name?: string | null;
  doctor_in_charge_in_hospital_last_name?: string | null;
  doctor_in_charge_in_hospital_phone?: string | null;
  early_rehabilitation_measures?: PredicamentYesNo | null;
  gender?: Gender | null;
  hospital_ik_number?: string | null;
  icd_code_1_code?: string | { value?: string } | null;
  icd_code_1_diagnosis?: string | null;
  icd_code_1_reason?: ICDReason | null;
  icd_code_1_side_localization_primary?: SideLocalization | null;
  icd_code_2_code?: string | null;
  icd_code_2_diagnosis?: string | null;
  icd_code_2_reason?: ICDReason | null;
  icd_code_2_side_localization_primary?: SideLocalization | null;
  icd_code_3_code?: string | { value?: string } | null;
  icd_code_3_diagnosis?: string | null;
  icd_code_3_reason?: ICDReason | null;
  icd_code_3_side_localization_primary?: SideLocalization | null;
  icd_code_4_code?: string | { value?: string } | null;
  icd_code_4_diagnosis?: string | null;
  icd_code_4_reason?: ICDReason | null;
  icd_code_4_side_localization_primary?: SideLocalization | null;
  icd_code_5_code?: string | { value?: string } | null;
  icd_code_5_diagnosis?: string | null;
  icd_code_5_reason?: ICDReason | null;
  icd_code_5_side_localization_primary?: SideLocalization | null;
  infections?: string | null;
  infections_state?: PredicamentYesNoUnknown | null;
  insurance_ik_number?: string | null;
  insurance_number?: string | null;
  interim_prosthesis_fitted?: PredicamentYesNo | null;
  limited_capacity?: PredicamentYesNo | null;
  operation_1_date?: number | null;
  operation_1_ops?: string[] | null;
  operation_1_wound_closed?: PredicamentYesNo | null;
  operation_2_date?: number | null;
  operation_2_ops?: string[] | null;
  operation_2_wound_closed?: PredicamentYesNo | null;
  operation_3_date?: number | null;
  operation_3_ops?: string[] | null;
  operation_3_wound_closed?: PredicamentYesNo | null;
  operation_4_date?: number | null;
  operation_4_ops?: string[] | null;
  operation_4_wound_closed?: PredicamentYesNo | null;
  operation_5_date?: number | null;
  operation_5_ops?: string[] | null;
  operation_5_wound_closed?: PredicamentYesNo | null;
  other_treatments?: string | null;
  patient_birthdate?: number | null;
  patient_first_name?: string | null;
  patient_last_name?: string | null;
  recommended_reha_type?: TypeOfRehab | null;
  recommended_reha_type_reason?: string | null;
  reha_capacity?: MuskuloskeletalResilience | null;
  reha_capacity_early_rehab_criteria?: EarlyRehabCriteria[] | null;
  reha_capacity_other?: string | null;
  reha_capacity_partial?: string | number | null;
  rehab_admission_outside_two_weeks_explanation?: string | null;
  rehab_admission_outside_two_weeks_start_date?: number | null;
  rehab_admission_type?: RehabAdmission | null;
  rehab_admission_within_two_weeks_start_date?: number | null;
  rehab_directive_state?: PredicamentYesNo | null;
  rehab_directive_type?: RehabDirectiveType | null;
  rehab_focus?: RehabFocus | null;
  rehab_focus_other_description?: string | null;
  rehabilitation_goals?: string | null;
  require_accompanying_person?: PredicamentYesNo | null;
  singer_assessment_concentration?: number | null;
  singer_assessment_date?: number | null;
  singer_assessment_domestic_life_household?: number | null;
  singer_assessment_dressing_and_undressing?: number | null;
  singer_assessment_food?: number | null;
  singer_assessment_hygiene?: number | null;
  singer_assessment_listening?: number | null;
  singer_assessment_orientation?: number | null;
  singer_assessment_planning?: number | null;
  singer_assessment_reading?: number | null;
  singer_assessment_shower?: number | null;
  singer_assessment_social_interaction?: number | null;
  singer_assessment_stairs?: number | null;
  singer_assessment_stool?: number | null;
  singer_assessment_talking?: number | null;
  singer_assessment_toilet_use?: number | null;
  singer_assessment_transfer?: number | null;
  singer_assessment_urination?: number | null;
  singer_assessment_walking?: number | null;
  singer_assessment_wheelchair?: number | null;
  singer_assessment_writing?: number | null;
  patient_body_height?: number | null;
  patient_body_weight?: number | null;
  special_requirements?: ValueOf<typeof SPECIAL_REQUIREMENTS>[] | null;
  special_requirements_decubitus_description?: string | null;
  special_requirements_dialysis_description?: string | null;
  special_requirements_other_description?: string | null;
  special_requirements_relatives_description?: string | null;
  special_requirements_required?: PredicamentYesNo | null;
  special_requirements_weight_bed_description?: string | null;
  surgery_performed?: PredicamentYesNo | null;
  transport_type?: TransportType | null;
  transport_type_ambulance_description?: string | null;
  transport_type_ambulance_specification?: TransportSubtype | null;
  transport_type_taxi_specification?: TransportSubtype | null;
  approved_by?: ApprovedByType | null;
  internal_complications_hide_error?: boolean;
};

export type DRVGeneralFormData = {
  application_submitted?: string | null;
  application_submitted_applicable?: PredicamentState | null;
  before_retirement_pension?: string | null;
  before_retirement_pension_applicable?: PredicamentState | null;
  care_person_necessary?: PredicamentState | null;
  claim_for_damages_approved?: PredicamentState | null;
  claim_for_damages_description?: number | null;
  claim_for_damages_file_number?: string | null;
  claim_for_damages_origin?: string | null;
  consent_of_the_insured?: LackOfCapacity | null;
  contact_guardian?: string | null;
  contributions_to_foreign_insurance_current?: PredicamentState | null;
  contributions_to_foreign_insurance_info?: PredicamentState | null;
  contributions_to_foreign_insurance_info_from_to?: string | null;
  contributions_to_foreign_insurance_info_state?: string | null;
  contributions_to_statutory_pension?: PredicamentState | null;
  doctor_in_charge_in_hospital?: string | null;
  doctor_in_charge_in_hospital_first_name?: string | null;
  doctor_in_charge_in_hospital_phone?: string | null;
  employment_status?: PriorEmploymentStatus | null;
  gender_extended?: Gender | null;
  health_damage_file_number?: string | null;
  health_damage_origin?: string | null;
  health_damage_present?: PredicamentState | null;
  health_damages_description?: string | null;
  hospital_name_address?: string | null;
  insurance_company_name_address?: string | null;
  insurance_name?: string | null;
  insurance_type?: HealthInsuranceType | null;
  jobcenter_name?: string | null;
  last_employment?: string | null;
  legal_guardian_email?: string | null;
  legal_guardian_house_number?: string | null;
  legal_guardian_phone?: string | null;
  legal_guardian_town?: string | null;
  legal_guardian_type?: LegalGuardian | null;
  legal_guardian_zip_code?: string | null;
  marital_status?: MaritalStatus | null;
  needs_disability_equipment?: string | null;
  needs_disability_equipment_applicable?: PredicamentState | null;
  patient_bank_account_holder?: string | null;
  patient_bank_iban?: string | null;
  patient_bank_name?: string | null;
  patient_birth_name?: string | null;
  patient_birthdate?: number | null;
  patient_city?: string | null;
  patient_first_name?: string | null;
  patient_last_name?: string | null;
  patient_maiden_name?: string | null;
  patient_nationality?: string | null;
  patient_phone_number?: string | null;
  patient_street_housenumber?: string | null;
  patient_unable_to_work_before_hospitalization?: PredicamentState | null;
  patient_unable_to_work_before_hospitalization_date?: number | null;
  patient_zipcode?: string | null;
  pension_insurance_company_name?: string | null;
  postal_code_doctor?: string | null;
  preferred_rehab_clinic?: string | null;
  prior_employment_status?: PriorEmploymentStatus | null;
  requested_rehab_service?: RequestedRehaService | null;
  requested_rehab_service_type_insured?: RequestedRehaServiceType | null;
  requested_rehab_service_type_relatives?: RequestedRehaServiceType | null;
  retirement_pension_received?: string | null;
  retirement_pension_received_applicable?: PredicamentState | null;
  risk_of_incapacity_caused_by_accident_third_person?: PredicamentState | null;
  send_documents_per_email?: boolean | null;
  send_documents_per_email_description?: string | null;
  social_worker_name_number?: string | null;
  special_payments_from_civil_services?: PredicamentState | null;
  statutory_pension_insurance_number?: string | null;
  street_house_number_doctor?: string | null;
  structured_treatment_plan?: string | null;
  third_party_request?: PredicamentState | null;
  town_doctor?: string | null;
  unemployment_benefit_type_2?: PredicamentState | null;
  visually_impaired_document?: VisuallyImpairedDocument[] | null;
};

export type DRVMedicalFormData = {
  admission_date?: number | null;
  carelevel?: CareLevel | null;
  carelevel_selected?: PredicamentState | null;
  clinical_findings?: string | null;
  complications?: string | null;
  current_therapy?: string | null;
  day_reha?: boolean | null;
  discharge_date?: number | null;
  drg_code?: string | null;
  drv_remarks?: string | null;
  eat_without_help?: PredicamentState | null;
  fecal_incontinence?: PredicamentState | null;
  full_reha?: boolean | null;
  further_therapeutic_diagnostic_measures_description?: string | null;
  further_therapeutic_diagnostic_measures_finished_on?: number | null;
  further_therapeutic_diagnostic_measures_from?: number | null;
  further_therapeutic_diagnostic_measures_to?: number | null;
  hospital_bank_holder?: string | null;
  hospital_bank_name?: string | null;
  hospital_billing_address?: string | null;
  hospital_iban?: string | null;
  hospital_ik_number?: string | null;
  hospital_name_address?: string | null;
  icd_code_1_code?: string | null;
  icd_code_2_code?: string | null;
  icd_code_3_code?: string | null;
  infections?: string | null;
  infections_selected?: PredicamentState | null;
  insurance_delivery_address?: string | null;
  main_diagnosis?: string | null;
  mobility_walk_without_help?: PredicamentState | null;
  mobility_wheel_chair?: PredicamentState | null;
  needs_catheter?: string | null;
  needs_catheter_selected?: PredicamentState | null;
  orientation_disoriented?: string | null;
  orientation_disoriented_selected?: PredicamentState | null;
  other_measures?: PredicamentState | null;
  outpatient_not_possible_reason?: OutPatientNotPossibleReason[] | null;
  patient_birthdate?: number | null;
  patient_city?: string | null;
  patient_height?: number | null;
  patient_name?: string | null;
  patient_street_housenumber?: string | null;
  patient_weight?: number | null;
  patient_zipcode?: string | null;
  pension_procedure_after_examination?: boolean | null;
  pension_procedure_direct?: boolean | null;
  preferred_rehab_clinic?: string | null;
  rehab_triggering_event?: RehabTriggeringEvent[] | null;
  rehab_triggering_event_date?: number | null;
  secondary_diagnosis?: string | null;
  secondary_diagnosis_selected?: PredicamentState | null;
  social_worker_name_number?: string | null;
  statutory_pension_insurance_number?: string | null;
  transfer_date?: number | null;
  transport_type?: PatientTransportType[] | null;
  urinary_incontinence?: PredicamentState | null;
  wash_and_dress_without_help?: PredicamentState | null;
  wound_closed?: PredicamentState | null;
};

/**
 * @deprecated to be replaced with {@link Filev2}
 */
export type Filev1 = Pick<EncryptedContent, "content" | "iv"> & {
  data?: ArrayBuffer;
  encrypted_name?: EncryptedField;
  link?: string;
  name?: string;
  title?: string;
  type?: string;
};

export type FileParams =
  | `patient_id=${number}`
  | `patient_id=${number}&without_form_side_effects=${boolean}`
  | `patient_id=${number}&scope=${FileScope}`
  | `patient_id=${number}&scope=${FileScope}&without_form_side_effects=${boolean}`
  | `patient_id=${number}&clinical_consultation_id=${number}`
  | `patient_id=${number}&clinical_consultation_id=${number}&without_form_side_effects=${boolean}`
  | `clinical_consultation_id=${number}`
  | `clinical_consultation_id=${number}&scope=${FileScope}`
  | `clinical_consultation_id=${number}&without_form_side_effects=${boolean}`
  | `clinical_consultation_id=${number}&scope=${FileScope}&without_form_side_effects=${boolean}`
  | `auction_id=${number}`
  | `auction_id=${number}&without_form_side_effects=${boolean}`
  | `patient_id=${number}&auction_id=${number}`
  | `patient_id=${number}&auction_id=${number}&without_form_side_effects=${boolean}`
  | `auction_id=${number}&scope=${FileScope}`
  | `auction_id=${number}&scope=${FileScope}&without_form_side_effects=${boolean}`
  | `patient_id=${number}&auction_id=${number}`
  | `patient_id=${number}&auction_id=${number}&scope=${FileScope}&without_form_side_effects=${boolean}`
  | `patient_id=${number}&auction_id=${number}&scope=${FileScope}`
  | `auction_request_id=${number}`
  | `auction_request_id=${number}&without_form_side_effects=${boolean}`
  | `auction_request_id=${number}&scope=${FileScope}`
  | `auction_request_id=${number}&scope=${FileScope}&without_form_side_effects=${boolean}`;

export type Filev2 = {
  __typename: string;
  account?: Account;
  auction_id: number;
  careprovider?: Careprovider;
  careseeker?: Careseeker;
  category_other?: string;
  category: FileCategory;
  created_at: number;
  file_name?: EncryptedField;
  file_scope?: FileScope;
  file_size?: number;
  file_type?: string;
  id: number;
  kis_document_id_string?: FileHISStateful["id"];
  link?: string;
  recare_file_type: RecareFileType;
  seald_encrypted_content?: {
    __typename: string;
    created_at?: string;
    file_id?: number;
    id?: number;
    seald_display_id?: string;
    seald_id?: string;
    seald_type?: number;
  };
  seald_encrypted_name?: string;
  seald_encryption_context?: EncryptionContext;
  share_mode: FileShareMode;
  share_options?: { account_id: number; mode: number };
  shared_by: Account;
  shared_with?: FileSharedWith;
  updated_at: number | null;
  form_synced_with_file?: boolean;
};

export type Filev2Stateful = Filev2 & {
  isNewVersionAvailable?: boolean;
  isFileDeleted?: boolean;
  fileDeletionType?: FileDeletionType;
};

export type FileHIS = {
  document_category_number: FileCategory;
  document_category_string: string;
  document_file_name: string;
  document_file_size: number;
  document_id: string;
  from_archive: boolean;
  updated_at: number;
  creation_date?: number;
};

export type FileForm = Omit<Filev2, "recare_file_type"> & {
  recare_file_type: FileFormType;
};

export type AllPatientForms = {
  auctionForms?: AuctionForm[];
};

export type FileTypeHIS = (typeof ALLOWED_EXTENSIONS_HIS)[number];

export type FileHISStateful = FileHIS & {
  id: FileHIS["document_id"];
  share_mode: FileShareMode;
  type: FileTypeHIS | null;
  unavailable_reason: FileError | null;
};

export type FilesHisParams = {
  externalId: string;
};

export type FileState = FileHISStateful | Filev2Stateful | FileForm;
export type FileTableActions = typeof FILE_TABLE_ACTIONS;
export type AccountTableActions = typeof ACCOUNT_TABLE_ACTIONS;

export type FileShareMode = (typeof FILE_SHARE_MODE_KINDS)[number];
export type FileScope = ValueOf<typeof FILE_SCOPE>;
export type RecareFileType = ValueOf<typeof RECARE_FILE_TYPE>;
export type FileFormType =
  | typeof RECARE_FILE_TYPE.DRV_GENERAL_FORM
  | typeof RECARE_FILE_TYPE.DRV_MEDICAL_FORM
  | typeof RECARE_FILE_TYPE.GKV_GENERAL_FORM
  | typeof RECARE_FILE_TYPE.GKV_MEDICAL_FORM
  | typeof RECARE_FILE_TYPE.TRANSITIONAL_CARE;

export type FileSharedWith = {
  __typename: string;
  careseeker_ids?: number[];
  selected_careproviders?: FilesSharedWithSelectedCareprovider[];
};

export type FilesSharedWithSelectedCareprovider = {
  __typename: string;
  account_id?: number;
  careprovider?: Careprovider;
};

export type FileTable =
  | "available"
  | "received"
  | "sent"
  | "unsupported"
  | "uploaded";

export type SelectableCareprovider = {
  id: number;
  name: string;
};

export type CareproviderFile = {
  content?: string;
  file_name: string;
  file_type: number;
  id: number;
  url: string;
};

export type DPAFileType = CareproviderFile & {
  church_owned: boolean;
  version: string;
};

export type CareproviderFiles = {
  documents?: Array<CareproviderFile>;
  images?: Array<CareproviderFile>;
  logo?: CareproviderFile;
};

export type FileCategory = ValueOf<typeof FILE_CATEGORIES>;
export type FileError = (typeof FILE_ERROR_TYPE)[number];

export type ProviderListing = {
  address?: CareproviderAddress;
  capacity?: {
    capacity_status?: CapacityStatus;
    updated_at?: number | null;
  };
  central_email?: string;
  central_phone_number?: string;
  distance?: number;
  facilities?: number[];
  id: number;
  is_consultant?: boolean;
  name?: string;
  project_sponsor?: string;
  thumbnail_url?: string;
  website?: string;
};

export type ProviderListingDetails = {
  address?: CareproviderAddress;
  capacity?: {
    capacity_status?: CapacityStatus;
    updated_at?: number | null;
  };
  central_email?: string;
  central_phone_number?: string;
  distance?: number;
  facilities?: Array<number>;
  fax_number?: string;
  files?: CareproviderFiles;
  id: number;
  name?: string;
  services?: Array<number>;
  website?: string;
};

export type EventFilter = {
  no_capacity_expiration?: number;
  no_capacity_reasons?: Array<NoCapacityReason>;
  type: number;
  value?: number;
  values?: Array<number>;
};

export type CapacityUpdate = {
  new_capacity?: Capacity;
  old_capacity?: Capacity;
};

export type EventContext = {
  __typename: string;
  accepted_solutions?: AcceptedSolution[];
  ahb_form?: {
    approved_by?: ApprovedByType;
    insurance_name?: string;
  } & AHBWithdrawFormValues;
  arrival_time?: string;
  author?: string;
  bounced_mails?: {
    __typename?: string; // #TODO: make requried
    bounced_emails: Array<string>;
    total_bounced: number;
    total_sent: number;
  };
  capacity_confirmed?: boolean;
  capacity_date?: number;
  capacity_update?: CapacityUpdate;
  careprovider_name?: string;
  clinic_internal_remarks?: string;
  declined_reason?: number;
  decrypted?: boolean;
  diff?: Array<string>;
  eligibility_reject_reason?: number;
  email?: string;
  file?: Filev1;
  file_type?: number;
  file_type_value?: RecareFileType;
  file_scope?: Filev2["file_scope"];
  filters?: Array<EventFilter>;
  form_type?: RecareFileType;
  insurance_name?: string;
  mail_type?: number;
  manual?: boolean;
  message?: string;
  message_iv?: string;
  messages?: Array<string>;
  new_assignee_name?: string;
  new_roles?: AccountRole[];
  new_stations?: string[];
  new_status?: number;
  no_capacity_expiration?: number;
  no_capacity_reasons?: Array<NoCapacityReason>;
  old_assignee_name?: string;
  onboarding_comment?: string;
  onboarding_email_type?: number;
  patient_type?: SearchType;
  possible_entry_date?: number;
  previous_status?: number;
  reason?: string;
  recipients?: Array<string>;
  reha_form_status?: number;
  request_link?: string;
  request_unavailable_reason?: number;
  seald_message?: string;
  solution_filter_reasons?: SolutionFilterReasons;
  stop_description?: string;
  stop_reason?: number;
  transferred_to_specialization?: Specialization;
  user_id?: string;
  winning_solution?: number;
};

export type BulkActionType = {
  selectedTotal: number;
  selectedTotalRequests: AuctionRequest[] | null | undefined;
  total: number;
  totalRequests: AuctionRequest[] | null | undefined;
  visibleTotal: number;
  visibleTotalRequests: AuctionRequest[] | null | undefined;
};

export type RequestPage = {
  hash: string;
  ids?: number[];
  // only in direct request tab
  redacted_count?: number;
  remaining: number;
  requests?: Array<AuctionRequest>;
  requests_light?: AuctionRequest[] | null | undefined;
  total: number;
};

export type Page<T> = {
  events: Array<T>;
  hash: string;
  remaining: number;
  total: number;
};

export type LastSeen = {
  account: Account;
  origin: number;
  timestamp?: number;
};

export type Origin = ValueOf<typeof ORIGIN>;
export type EventType = ValueOf<typeof EVENTS>;

export type Event = {
  __typename: string;
  account?: Account;
  careprovider?: Careprovider;
  careseeker?: Careseeker;
  context?: EventContext;
  id?: number;
  last_seens?: LastSeen[];
  origin?: Origin;
  patient_id?: number;
  seen_by_recipient?: boolean;
  seen_by_recipient_timestamp?: number;
  subject_account?: Account;
  timestamp?: number;
  type?: EventType;
  user_id?: string;
};

type IntegrationEventType = ValueOf<typeof INTEGRATION_EVENT_TYPES>;
type IntegrationEventStatus = ValueOf<typeof INTEGRATION_EVENT_STATUSES>;

export type IntegrationEvent = {
  created_at: string;
  event_type: IntegrationEventType;
  status: IntegrationEventStatus;
};

export type NotificationEvent = Exclude<Event, "user_id"> & {
  auction?: Auction;
  auction_request?: AuctionRequest & { solution?: number };
};

export type PageView = {
  account?: Account;
  auction_request_id?: number;
  id?: number;
  timestamp?: number;
};

export type RehabFormOld = {
  medical_form_input?: UserInput;
  request_form_input?: UserInput;
};

export type UserInput = EncryptedContent & {
  type?: string;
  updated_at?: number;
};

export type Station = {
  __typename?: string;
  description?: string;
  id?: number;
  name?: string;
  phone_number?: string;
};

export type EncryptedContent = {
  __typename?: string;
  content: string | null | undefined;
  iv: string | null | undefined;
  seald_content: string | null | undefined;
};

export type EncryptedField = EncryptedContent & {
  decrypted?: string | null | undefined;
};

export type SessionKeyContext = {
  __typename?: string;
  has_session_keys: boolean;
  session_key?: SessionKey;
};

export type PatientSearchItem = Pick<
  Patient,
  "user_id" | "external_id" | "id" | "created_at"
>;

export type Patient = {
  __typename?: string;
  archived?: boolean;
  assignee?: Account;
  auctions?: Array<Auction>;
  care_needs?: PatientNeeds;
  careseeker?: Careseeker;
  careseeker_id?: number;
  created_at?: number;
  diagnosis?: MedicalDiagnosis;
  drg_code?: string;
  events?: Array<Event>;
  external_id?: string;
  id: number;
  kis_import?: boolean;
  last_action?: LastAction | null;
  profile?: PatientProfile;
  quick_save?: boolean;
  rehab_form?: RehabFormOld;
  seald_encryption_context?: EncryptionContext;
  session_key_context?: SessionKeyContext;
  session_keys?: Array<SessionKey>;
  social_worker?: Account;
  station?: string;
  station_full?: Station;
  station_full_id?: number;
  transport?: PatientTransport;
  user_id?: string;
  version?: string;
};

export type PatientByExternalId = Pick<Patient, "id" | "external_id"> & {
  clinical_consultations?: ClinicalConsultation[];
};

export type PatientWithClinicalConsultations = Pick<
  Patient,
  "id" | "external_id" | "seald_encryption_context"
> & {
  profile?: ClinicalPatientProfile;
  clinical_consultations?: ClinicalConsultation[];
};

export type ClinicalConsultationActionType = ValueOf<
  typeof CLINICAL_CONSULTATION_ACTION
>;
export type ClinicalConsultationAction = {
  action_type: ClinicalConsultationActionType;
  context?: ClinicalConsultationActionContext;
};

export type ClinicalConsultationActionContext = {
  disabled?: boolean;
  values?: number[];
};

export type ClinicalConsultation = {
  actions?: ClinicalConsultationAction[];
  forms?: AuctionForm[];
  id: number;
  created_at?: number;
  updated_at?: number;
  patient_id?: number;
  seald_encryption_context?: EncryptionContext;
};

export type ClinicalPatientProfile = Pick<
  PatientProfile,
  "birth_date" | "discharge_date" | "first_name" | "gender" | "last_name"
>;

export type ClinicalPatientDiagnosis = Pick<
  MedicalDiagnosis,
  "hl7_main_diagnoses" | "hl7_secondary_diagnoses" | "main_diagnosis"
>;

export type ClinicalPatient = Pick<
  Patient,
  "external_id" | "id" | "seald_encryption_context" | "user_id"
> & {
  diagnosis?: ClinicalPatientDiagnosis | null;
  profile?: ClinicalPatientProfile | null;
};

export type ClinicalPatientConnection = {
  items_per_page: number;
  page: number;
  patients: ClinicalPatient[];
  total_items: number;
};

export type PaginatedQueryResult<T> = {
  data: T[] | undefined;
  isLoading: boolean;
  total: number;
};

export type PatientTransport = {
  accompanying_person?: EncryptedField | null;
  daily_transport_needed?: boolean;
  require_accompanying_person?: boolean;
  transport_organiser?: string;
  transport_type?: PatientTransportType[];
};

type NoCapacityReasonType =
  | typeof NO_CAPACITY_FOR_CARELEVEL
  | typeof NO_CAPACITY_FOR_GENDER
  | typeof NO_CAPACITY_FOR_INFECTION
  | typeof NO_CAPACITY_FOR_ROOM
  | typeof NO_CAPACITY_FOR_SERVICE
  | typeof NO_CAPACITY_FOR_SOLUTION
  | typeof NO_CAPACITY_FOR_SPECIALIZATION;

export type NoCapacityReason = {
  type: NoCapacityReasonType;
  values: number[];
};

export type AuctionResponse = {
  __typename: string;
  accepted_solutions?: AcceptedSolution[];
  arrival_time?: string;
  capacity_date?: number;
  declined_reason?: number;
  message?: string | null;
  message_iv?: string;
  no_capacity_expiration?: number;
  no_capacity_reasons?: Array<NoCapacityReason> | undefined;
  possible_entry_date?: number;
  status?: number;
  updated_at?: number;
};

export type AuctionValidation = {
  auto_validated?: boolean;
  created_at?: number;
  internal_remarks?: string | null;
  message?: string;
  message_iv?: string;
  solution?: number;
  status?: number;
  updated_at?: number;
  validation_reason?: string;
};

export type RequestActionVariantType = (typeof REQUEST_ACTION_VARIANTS)[number];
export type RequestActionType = (typeof REQUEST_ACTION_TYPES)[number];
export type UndoActionType = (typeof REQUEST_ACTION_UNDO_TYPES)[number];
export type DisabledRequestActionType =
  (typeof REQUEST_CONTEXT_DISABLED_TYPES)[number];

export type UndoRequestAction = {
  action_type: UndoActionType;
  context?: null;
};

export type RequestActionContext = {
  disabled?: DisabledRequestActionType;
  variant?: RequestActionVariantType;
};

export type RequestAction = {
  action_type: RequestActionType;
  context?: RequestActionContext;
};

export type RequestActionTypes = RequestAction | UndoRequestAction;

export type RequestActions = RequestActionTypes[];

export type AcceptedSolution = {
  arrival_time?: string;
  possible_entry_date?: number;
  solution: number;
};

type MinimalRoles = Omit<Roles, "careprovider_roles" | "careseeker_roles"> & {
  careprovider_roles?: Array<
    Omit<CareproviderRole, "careprovider"> & {
      careprovider?: { __typename: string; id: number };
    }
  >;
  careseeker_roles?: Array<
    Omit<CareseekerRole, "careseeker"> & {
      careseeker?: { __typename: string; id: number };
    }
  >;
};

// careprovider/ careseeker in AuctionRequest account roles reduced to just their ids
export type AccountInAuctionRequest = Omit<Account, "roles"> & {
  roles: MinimalRoles;
};

export type AuctionRequest = {
  __typename: string;
  access_request_pending?: boolean;
  accounts?: AccountInAuctionRequest[];
  action_required_by_user?: boolean;
  archived?: boolean;
  assignee?: Assignee;
  assignee_id?: number;
  auction?: Auction;
  auction_id?: number;
  careprovider?: Careprovider;
  careprovider_notes?: CareproviderNote[];
  careprovider_id?: number;
  created_at?: number;
  deleted_at?: number;
  request_origin?: AuctionRequestOrigin;
  distance?: number;
  events?: Event[];
  fax_sent?: boolean;
  files_count?: number;
  has_capacity?: boolean;
  has_seald_encryption_context?: boolean;
  has_session_keys?: boolean;
  id: number;
  is_seald_only_encryption?: boolean;
  is_recommendation?: boolean;
  is_reverse_search_match?: boolean;
  last_action?: LastAction;
  last_event?: Event;
  last_integration_event?: IntegrationEvent;
  last_seens?: Array<PageView>;
  manually_added?: boolean;
  messages_count?: number;
  messenger_available?: boolean;
  patient_preferred?: boolean;
  patient_preferred_reason?: string;
  preferred?: boolean;
  request_actions?: RequestActions;
  response?: AuctionResponse | null;
  seald_encryption_context?: EncryptionContext;
  seen_by_user?: boolean;
  send_fax?: boolean;
  session_key?: SessionKey;
  session_key_context?: SessionKeyContext;
  solutions?: Solutions;
  status?: number;
  token?: string;
  updated_at?: number;
  validation?: AuctionValidation;
};

export type AuctionRequestOrigin = ValueOf<typeof AUCTION_REQUEST_ORIGIN>;

export type CareproviderNote = {
  id: number;
  created_at: number;
  updated_at: number;
  account: Account;
  message: EncryptedField;
};

export type CareLevel = ValueOf<typeof CARE_LEVELS>;

export type CareLevelInfos = {
  __typename?: string;
  expedited_request?: boolean;
  has_applied?: boolean;
  higher_level?: boolean;
  level: CareLevel | undefined;
};

export type MentalHealthNestedField = {
  state?: number;
  description?: string;
};

export type SuicidalityField = MentalHealthNestedField & {
  passive_thoughts?: boolean;
  active_thoughts?: boolean;
  concrete_plans?: boolean;
  preparatory_actions?: boolean;
  previous_attempts?: boolean;
};

export type SelfHarmField = MentalHealthNestedField & {
  cutting?: boolean;
  scratching?: boolean;
  hitting_surfaces?: boolean;
  hitting_self?: boolean;
  biting?: boolean;
  burning?: boolean;
};

export type EndangermentOfOthersField = MentalHealthNestedField & {
  aggressive_impulses?: boolean;
  verbal_aggression?: boolean;
  physical_aggression?: boolean;
  concrete_threats?: boolean;
  lack_of_impulse_control?: boolean;
};

export type SubstanceUseField = MentalHealthNestedField & {
  occasional_use?: boolean;
  harmful_use?: boolean;
  dependency?: boolean;
  consumed_substances?: string;
};

export type BriefSociopsychiatricAssessment = {
  contact_behavior?: number;
  contact_behavior_description?: string;
  daily_structure_participation?: number;
  daily_structure_participation_description?: string;
  gaf_score?: number;
  motivation?: number;
  motivation_description?: string;
};

export type MentalHealth = {
  aggressivity?: boolean;
  anxiety?: boolean;
  brief_sociopsychiatric_assessment?: BriefSociopsychiatricAssessment;
  closed_station?: boolean;
  communication?: number;
  consciousness?: number;
  consciousness_description?: string;
  dangerous?: boolean;
  dementia?: number;
  dementia_description?: string;
  depression?: boolean;
  endangerment?: number;
  endangerment_description?: string;
  endangerment_of_others?: EndangermentOfOthersField;
  fixation?: boolean;
  mental_issues?: string;
  motivation?: number;
  night_watch_description?: string;
  non_suicidal_self_harm?: number;
  orientation?: number;
  orientation_person?: number;
  orientation_person_description?: string;
  orientation_place?: number;
  orientation_place_description?: string;
  orientation_situation?: number;
  orientation_situation_description?: string;
  orientation_time?: number;
  orientation_time_description?: string;
  protected_area_needed?: string;
  run_away_description?: string;
  self_endangerment_description?: string;
  self_harm?: SelfHarmField;
  substance_use?: SubstanceUseField;
  substance_use_description?: string;
  suicidality?: SuicidalityField;
  suicidality_description?: string;
  vigilance?: number;
};

export type Palliative = {
  description: string | undefined;
  palliative_certificate_needed?: boolean;
};

export type IcdCode = {
  code: string;
  description: string;
};

export type GetOntologyType = ({
  key,
  type,
  useShortValues,
}: {
  key: number | null | undefined;
  type: OntologyType;
  useShortValues?: boolean;
}) => string;

export type GetOntologiesType = ({
  sort,
  type,
}: {
  sort?: boolean;
  type: OntologyType;
}) => {
  label: string;
  value: number;
}[];

export type CoronaTest = {
  corona?: {
    __typename?: string;
    description?: string | null | undefined;
    test_result?: number | null | undefined;
    vaccinated?: string | null | undefined;
  };
  corona_state?: number | null | undefined;
};

export type HL7Diagnosis = {
  code?: string;
  description?: string;
  type?: string;
};

export type MedicalDiagnosis = {
  __typename?: string;
  addictions?: string;
  additional_examinations_necessary?: string;
  additional_icd_codes?: Array<IcdCode>;
  allergies?: string;
  chronic_pains?: string;
  corona?: CoronaTest["corona"];
  corona_state?: CoronaTest["corona_state"];
  dependency_diagnosis?: DependencyDiagnosis;
  dysphagia?: string;

  // Only used for analytics purposes for now.
  hl7_diagnoses?: HL7Diagnosis[] | undefined;
  hl7_main_diagnoses?: HL7Diagnosis[] | undefined;
  hl7_secondary_diagnoses?: HL7Diagnosis[] | undefined;

  hospital_stay?: HospitalStay;
  icd_code?: IcdCode;
  infection_and_germs?: InfectionAndGerms;
  infection_and_germs_state?: number;
  limited_capacity?: LimitedCapacity;
  main_diagnosis?: string;
  medical_history?: string;
  mental_health?: MentalHealth;
  multimorbidity?: boolean;
  palliative?: Palliative;
  physical_disabilities?: PhysicalDisabilities;
  rehabilitation_goals?: string;
  rehabilitation_potential?: RehabilitationPotential;
  secondary_diagnosis?: string;
};

export type Candidates = {
  count: number;
};

export type RCryptoKey = {
  account_id: number;
  created_at?: number;
  id?: number;
  private_iv: string;
  private_key_fiftyk?: string;
  private_key_fivek?: string;
  private_key_twenty_fivek?: string;
  public_key: string;
  salt: string;
  updated_at?: number;
};

export type SessionKey = {
  account_id: number;
  algorithm: string | null;
  auction_request_id: number | undefined;
  careprovider_id: number | undefined;
  careseeker_id?: number;
  id?: number;
  patient_id: number | undefined;
  session_key: string;
  updated_at: number;
};

export type PendingSessionKey = {
  account_id: number;
  account_public_key: string;
  algorithm: string | null;
  auction_request_id: number | undefined;
  careprovider_id: number | undefined;
  careseeker_id: number | undefined;
  created_at: number;
  patient_id: number | undefined;
  user_session_key: string;
};

export type FhirAddress<T = EncryptedField | string> = {
  _line?: { extension: { valueString: T }[] }[];
  houseNumber?: T;
  line?: string[];
}[];

export type FhirEntry<T = EncryptedField | string> = {
  resource?: Record<string, any> & {
    address?: FhirAddress<T>;
    birthDate?: T;
    code?: { text?: T };
    name?: { family?: T; given?: T | T[] }[];
    resourceType?: string;
    valueQuantity?: { value?: T };
  };
};

type FhirPatientType<T = EncryptedField | string> = {
  entry?: Array<FhirEntry<T>>;
  id?: string;
  resourceType?: string;
  timestamp?: string;
  type?: string;
};

export type EncryptedFhirPatient = FhirPatientType<EncryptedField>;
export type DecryptedFhirPatient = FhirPatientType<string>;

export type EncryptionJob = {
  auction_id?: number;
  fhir_patient?: EncryptedFhirPatient;
  id: number;
  is_integration_v2?: boolean;
  patient_encrypted_session_key?: SessionKey;
  patient_seald_encryption_context?: EncryptionContext;
  receiver_integration_public_key?: string;
};

export type Interval = {
  __typename?: string;
  max?: number;
  min?: number;
};

export type CareproviderOnboarding = {
  call_back_date?: number;
  comment?: string;
  facility_size?: number;
  information_system?: number;
  information_system_other?: string;
  new_facility_openings?: number;
  responsible_person?: number;
  status: number;
  waiting_list_usage?: number;
};

export type RelatedCareseeker = {
  careseeker?: Careseeker;
  distance: number;
  prioritized: boolean;
};

export type Env = "demo" | "development" | "preprod" | "production" | "staging";

export type EnvContext = {
  app: AppType;
  config: ConfigType | null;
  env: Env;
  isAcpApp: boolean;
  isProviderSearchApp: boolean;
  isReceiverApp: boolean;
  isSenderApp: boolean;
  setEnv: (env: Env, newPrName?: string) => void;
};

type AlgoliaApiKey = {
  apiKey: string;
  appId: string;
};
export type AlgoliaApiKeysByApp = Record<AppType, string>;

export type ConfigType = {
  opensearch: {
    baseUrl: string;
    aws: {
      accessKeyId: string;
      secretAccessKey: string;
    };
  };
  algolia: AlgoliaApiKey;
  backend: Record<
    Backend,
    {
      host?: string;
      port?: number;
      protocol?: string;
      url?: string;
    }
  >;
  looker: {
    host: string;
    dashboardId: Record<AnalyticsSection, number>;
  };
  environment: Env;
  friendlyCaptcha: {
    sitekey: string;
  };
  intercom: {
    faqUrl: { [key: string]: string };
    key: string;
  };
  mapbox: string;
  seald: {
    apiUrl: string;
    appId: string;
    ssksUrl: string;
  };
  salesforce: {
    orgId: string;
    embeddedServiceName: string;
    baseUrl: string;
    scrt2URL: string;
    language: Locale;
    bootstrapScriptUrl: string;
  };
  skippedVersion?: number;
  version?: string;
};

export type InfoBannerAction = {
  id?: string;
  label: string;
  onClick: () => void;
  tour?: TourElement;
};

export type Notification = {
  a11yType?: A11yStatusUpdate["role"];
  actions?: InfoBannerAction[];
  key?: string;
  message: string;
  shouldFocus?: boolean;
  type?: NotifyVariant;
};

export type NotifyVariant = "error" | "success" | undefined;

export type Notify = (options: Notification) => void;

/**
 * @deprecated use {@link BarthelAssessment}
 */
export type BarthelIndex = {
  date: number;
  deleted?: boolean;
  form: {
    bathing: number | null | undefined;
    dressing_and_undressing: number | null | undefined;
    fecal_incontinence: number | null | undefined;
    food: number | null | undefined;
    getting_up_and_walking: number | null | undefined;
    personal_care: number | null | undefined;
    setting_up_and_relocating: number | null | undefined;
    stair_climbing: number | null | undefined;
    toilet_use: number | null | undefined;
    urinary_incontinence: number | null | undefined;
  };
};
export type BarthelAssessment = {
  __typename?: string;
  date?: number;
  form?: {
    __typename?: string;
    bathing: number;
    dressing_and_undressing: number;
    fecal_incontinence: number;
    food: number;
    getting_up_and_walking: number;
    personal_care: number;
    setting_up_and_relocating: number;
    stair_climbing: number;
    toilet_use: number;
    urinary_incontinence: number;
  };
  score?: number;
};

/**
 * @deprecated use {@link EarlyRehabAssessment}
 */
export type RehabIndex = {
  date: number;
  form: {
    behavioural_disorder: number | null | undefined;
    intensive_medical_monitoring: number | null | undefined;
    intermittent_ventilation: number | null | undefined;
    orientation_disorder: number | null | undefined;
    severe_communication_disorder: number | null | undefined;
    supervised_swallowing_disorder: number | null | undefined;
    tracheostoma_requiring_aspiration: number | null | undefined;
  };
};

export type EarlyRehabAssessment = {
  __typename?: string;
  date?: number;
  form?: {
    __typename?: string;
    behavioural_disorder?: number;
    intensive_medical_monitoring?: number;
    intermittent_ventilation?: number;
    orientation_disorder?: number;
    severe_communication_disorder?: number;
    supervised_swallowing_disorder?: number;
    tracheostoma_requiring_aspiration?: number;
  };
  score?: number;
};

export type PatientWhitelistDefinition = PatientWhitelistScope[];

export type PatientWhitelistProps = {
  careseeker?: Careseeker | null;
  formInputValue: Auction | null | undefined;
};

export type PatientInfoWhitelist = {
  accompanying_person: PatientWhitelistDefinition;
  accompanying_person_description: PatientWhitelistDefinition;
  age_interval: PatientWhitelistDefinition;
  barrier_free_room: PatientWhitelistDefinition;
  birth_date: PatientWhitelistDefinition;
  carelevel: PatientWhitelistDefinition;
  civil_servants_aid: PatientWhitelistDefinition;
  decisions_and_language: PatientWhitelistDefinition;
  encrypted_house_number: PatientWhitelistDefinition;
  expedited_request: PatientWhitelistDefinition;
  financing: PatientWhitelistDefinition;
  financing_insurance: PatientWhitelistDefinition;
  first_name: PatientWhitelistDefinition;
  free_from_supplementary_payment_state: PatientWhitelistDefinition;
  further_information: PatientWhitelistDefinition;
  gender: PatientWhitelistDefinition;
  general_practitioner: PatientWhitelistDefinition;
  general_practitioner_contact_details: PatientWhitelistDefinition;
  general_practitioner_name: PatientWhitelistDefinition;
  general_practitioner_first_name: PatientWhitelistDefinition;
  general_practitioner_last_name: PatientWhitelistDefinition;
  general_practitioner_honorific_prefix: PatientWhitelistDefinition;
  general_practitioner_honorific_suffix: PatientWhitelistDefinition;
  general_practitioner_street: PatientWhitelistDefinition;
  general_practitioner_house_number: PatientWhitelistDefinition;
  general_practitioner_city: PatientWhitelistDefinition;
  general_practitioner_zipcode: PatientWhitelistDefinition;
  general_practitioner_phone: PatientWhitelistDefinition;
  general_practitioner_job_title: PatientWhitelistDefinition;
  guardian_contact_information: PatientWhitelistDefinition;
  psychiatrist: PatientWhitelistDefinition;
  psychiatrist_city: PatientWhitelistDefinition;
  psychiatrist_first_name: PatientWhitelistDefinition;
  psychiatrist_honorific_prefix: PatientWhitelistDefinition;
  psychiatrist_honorific_suffix: PatientWhitelistDefinition;
  psychiatrist_house_number: PatientWhitelistDefinition;
  psychiatrist_job_title: PatientWhitelistDefinition;
  psychiatrist_last_name: PatientWhitelistDefinition;
  psychiatrist_phone: PatientWhitelistDefinition;
  psychiatrist_street: PatientWhitelistDefinition;
  psychiatrist_zipcode: PatientWhitelistDefinition;
  guardian_requested: PatientWhitelistDefinition;
  guardians: PatientWhitelistDefinition;
  has_applied: PatientWhitelistDefinition;
  has_guardian: PatientWhitelistDefinition;
  height: PatientWhitelistDefinition;
  higher_level: PatientWhitelistDefinition;
  insurance_id: PatientWhitelistDefinition;
  insurance_number: PatientWhitelistDefinition;
  last_name: PatientWhitelistDefinition;
  level: PatientWhitelistDefinition;
  lift_available_description: PatientWhitelistDefinition;
  lift_available_state: PatientWhitelistDefinition;
  living_situation: PatientWhitelistDefinition;
  living_situation_other: PatientWhitelistDefinition;
  location: PatientWhitelistDefinition;
  more_information: PatientWhitelistDefinition;
  other_payer: PatientWhitelistDefinition;
  patient_cannot_communicate_in_german: PatientWhitelistDefinition;
  patient_is_contact: PatientWhitelistDefinition;
  patient_is_contact_description: PatientWhitelistDefinition;
  patient_language: PatientWhitelistDefinition;
  patient_uses_sign_language: PatientWhitelistDefinition;
  payers: PatientWhitelistDefinition;
  payers_insurance: PatientWhitelistDefinition;
  payout: PatientWhitelistDefinition;
  preferences: PatientWhitelistDefinition;
  preventative_care: PatientWhitelistDefinition;
  private_payment_bool: PatientWhitelistDefinition;
  public_accident_insurance: PatientWhitelistDefinition;
  public_care_insurance_status: PatientWhitelistDefinition;
  public_pension: PatientWhitelistDefinition;
  radius_in_km: PatientWhitelistDefinition;
  reimbursment_for_help_at_home: PatientWhitelistDefinition;
  reimbursment_secured: PatientWhitelistDefinition;
  relatives_available: PatientWhitelistDefinition;
  relatives_description: PatientWhitelistDefinition;
  relief_services: PatientWhitelistDefinition;
  room_type: PatientWhitelistDefinition;
  selected_payment_method: PatientWhitelistDefinition;
  self_payer: PatientWhitelistDefinition;
  short_term_care: PatientWhitelistDefinition;
  social_help_recipient_bool: PatientWhitelistDefinition;
  social_service_department: PatientWhitelistDefinition;
  specialist_doctor: PatientWhitelistDefinition;
  supplementary_insurance: PatientWhitelistDefinition;
  supplementary_insurance_state: PatientWhitelistDefinition;
  supplementary_payment: PatientWhitelistDefinition;
  supplementary_payment_state: PatientWhitelistDefinition;
  unsafe_current_domestic_situation: PatientWhitelistDefinition;
  unsafe_current_domestic_situation_state: PatientWhitelistDefinition;
  weight: PatientWhitelistDefinition;
};

export type CSSPosition =
  | "-moz-initial"
  | "-webkit-sticky"
  | "absolute"
  | "fixed"
  | "inherit"
  | "initial"
  | "relative"
  | "revert"
  | "static"
  | "sticky"
  | "unset"
  | undefined;

export type CSSTextAlign =
  | "-moz-initial"
  | "center"
  | "end"
  | "inherit"
  | "initial"
  | "justify"
  | "left"
  | "match-parent"
  | "revert"
  | "right"
  | "start"
  | "unset"
  | undefined;

export type PatientMedicalWhitelist = {
  addictions: PatientWhitelistDefinition;
  additional_icd_codes: PatientWhitelistDefinition;
  allergies: PatientWhitelistDefinition;
  barthel_assessment: PatientWhitelistDefinition;
  chronic_pains: PatientWhitelistDefinition;
  clostridien: PatientWhitelistDefinition;
  corona: PatientWhitelistDefinition;
  corona_state: PatientWhitelistDefinition;
  dependency_level: PatientWhitelistDefinition;
  doctor_in_charge_in_hospital: PatientWhitelistDefinition;
  doctor_in_charge_in_hospital_phone: PatientWhitelistDefinition;
  dysphagia: PatientWhitelistDefinition;
  early_rehab_assessment: PatientWhitelistDefinition;
  evaluation: PatientWhitelistDefinition;
  four_mrgn: PatientWhitelistDefinition;
  geriatric_early_stage: PatientWhitelistDefinition;
  help_at_home: PatientWhitelistDefinition;
  hospital_stay: PatientWhitelistDefinition;
  icd_code: PatientWhitelistDefinition;
  icd_codes: PatientWhitelistDefinition;
  infection_and_germs: PatientWhitelistDefinition;
  infection_and_germs_state: PatientWhitelistDefinition;
  limited_capacity: PatientWhitelistDefinition;
  limited_capacity_other: PatientWhitelistDefinition;
  limited_cognitive_capacity: PatientWhitelistDefinition;
  limited_physical_capacity: PatientWhitelistDefinition;
  limited_psychological_capacity: PatientWhitelistDefinition;
  limited_social_behaviour: PatientWhitelistDefinition;
  main_diagnosis: PatientWhitelistDefinition;
  mrsa: PatientWhitelistDefinition;
  multimorbidity: PatientWhitelistDefinition;
  operation_date: PatientWhitelistDefinition;
  operation_description: PatientWhitelistDefinition;
  other: PatientWhitelistDefinition;
  rehabilitation_goals: PatientWhitelistDefinition;
  rehabilitation_potential: PatientWhitelistDefinition;
  rehabilitation_potential_description: PatientWhitelistDefinition;
  remarks: PatientWhitelistDefinition;
  requires_isolation: PatientWhitelistDefinition;
  secondary_diagnosis: PatientWhitelistDefinition;
  singer_assessment: PatientWhitelistDefinition;
  three_mrgn: PatientWhitelistDefinition;
  vre: PatientWhitelistDefinition;
};

export type PatientTransportWhitelist = {
  accompanying_person: PatientWhitelistDefinition;
  daily_transport_needed: PatientWhitelistDefinition;
  require_accompanying_person: PatientWhitelistDefinition;
  transport_organiser: PatientWhitelistDefinition;
  transport_type: PatientWhitelistDefinition;
};

export type PatientMobilityWhitelist = {
  assistive_equipment: PatientWhitelistDefinition;
  auditive_impairment: PatientWhitelistDefinition;
  existing_medical_supplies: PatientWhitelistDefinition;
  mobility: PatientWhitelistDefinition;
  mobility_additional_information: PatientWhitelistDefinition;
  orthese: PatientWhitelistDefinition;
  prescribed_medical_supplies: PatientWhitelistDefinition;
  prothese: PatientWhitelistDefinition;
  required_medical_supplies: PatientWhitelistDefinition;
  visual_impairment: PatientWhitelistDefinition;
};

export type PatientNeedsWhitelist = {
  access_drainages: PatientWhitelistDefinition;
  base_care: PatientWhitelistDefinition;
  base_care_companionship_grant: PatientWhitelistDefinition;
  base_care_description: PatientWhitelistDefinition;
  basic_medical_care_description: PatientWhitelistDefinition;
  body_care: PatientWhitelistDefinition;
  breathing: PatientWhitelistDefinition;
  central_venous_catheter: PatientWhitelistDefinition;
  circulation: PatientWhitelistDefinition;
  companionship: PatientWhitelistDefinition;
  companionship_description: PatientWhitelistDefinition;
  companionship_grant: PatientWhitelistDefinition;
  compression: PatientWhitelistDefinition;
  compression_description: PatientWhitelistDefinition;
  dialysis: PatientWhitelistDefinition;
  drainage: PatientWhitelistDefinition;
  dressing: PatientWhitelistDefinition;
  dysphagia: PatientWhitelistDefinition;
  eating: PatientWhitelistDefinition;
  enteral_nutrition: PatientWhitelistDefinition;
  fecal_incontinence: PatientWhitelistDefinition;
  gastric_tube: PatientWhitelistDefinition;
  help_at_home: PatientWhitelistDefinition;
  help_at_home_description: PatientWhitelistDefinition;
  hemodialysis: PatientWhitelistDefinition;
  incontinence: PatientWhitelistDefinition;
  injection: PatientWhitelistDefinition;
  injection_description: PatientWhitelistDefinition;
  medication: PatientWhitelistDefinition;
  medication_description: PatientWhitelistDefinition;
  metabolism: PatientWhitelistDefinition;
  monitoring: PatientWhitelistDefinition;
  nutrition: PatientWhitelistDefinition;
  oxygen_therapy: PatientWhitelistDefinition;
  palliative: PatientWhitelistDefinition;
  palliative_certificate_needed: PatientWhitelistDefinition;
  palliative_description: PatientWhitelistDefinition;
  parenteral_nutrition: PatientWhitelistDefinition;
  peripheral_venous_catheter: PatientWhitelistDefinition;
  peritoneal_dialysis: PatientWhitelistDefinition;
  permanent_catheter: PatientWhitelistDefinition;
  psychiatric_care: PatientWhitelistDefinition;
  psychiatric_care_description: PatientWhitelistDefinition;
  remarks: PatientWhitelistDefinition;
  respiration: PatientWhitelistDefinition;
  specialised_intensive_nurse: PatientWhitelistDefinition;
  support: PatientWhitelistDefinition;
  suprapubic_catheter: PatientWhitelistDefinition;
  tracheal_cannula: PatientWhitelistDefinition;
  tracheostomy: PatientWhitelistDefinition;
  urinary_catheter: PatientWhitelistDefinition;
  urinary_incontinence: PatientWhitelistDefinition;
  wound_care: PatientWhitelistDefinition;
  wound_care_description: PatientWhitelistDefinition;
  integration_assistance: PatientWhitelistDefinition;
  integration_assistance_description: PatientWhitelistDefinition;
};

export type PatientMentalWhitelist = {
  aggressivity: PatientWhitelistDefinition;
  anxiety: PatientWhitelistDefinition;
  closed_station: PatientWhitelistDefinition;
  communication: PatientWhitelistDefinition;
  dangerous: PatientWhitelistDefinition;
  dementia_description: PatientWhitelistDefinition;
  depression: PatientWhitelistDefinition;
  fixation: PatientWhitelistDefinition;
  mental_issues: PatientWhitelistDefinition;
  mental_state_fields: PatientWhitelistDefinition;
  motivation: PatientWhitelistDefinition;
  night_watch_description: PatientWhitelistDefinition;
  orientation: PatientWhitelistDefinition;
  protected_area_needed: PatientWhitelistDefinition;
  run_away_description: PatientWhitelistDefinition;
  vigilance: PatientWhitelistDefinition;
};

export type GenericWhitelist = Record<string, PatientWhitelistDefinition>;

export type PatientTransferWhitelist = GenericWhitelist;

export type PrecomputePatientWhitelist = {
  [ASSESSMENT_SLUG.ELECTIVE_REHAB_INFO]: GenericWhitelist;
  [ASSESSMENT_SLUG.ELECTIVE_REHAB_MEDICAL]: GenericWhitelist;
  [ASSESSMENT_SLUG.HOME_CARE_INFO]: GenericWhitelist;
  [ASSESSMENT_SLUG.HOME_CARE_SEARCH]: GenericWhitelist;
  [ASSESSMENT_SLUG.MEDICAL_SUPPLIES_CATALOGUE]: GenericWhitelist;
  [ASSESSMENT_SLUG.MEDICAL_SUPPLIES_INFO]: GenericWhitelist;
  [ASSESSMENT_SLUG.MOBILE_SHORT]: GenericWhitelist;
  [ASSESSMENT_SLUG.PSYCH_EVALUATION]: GenericWhitelist;
  [ASSESSMENT_SLUG.PSYCH_INFO]: PatientInfoWhitelist;
  [ASSESSMENT_SLUG.PSYCH_NEEDS]: GenericWhitelist;
  [ASSESSMENT_SLUG.TRANSPORT_INFO]: GenericWhitelist;
  [ASSESSMENT_SLUG.TRANSPORT_SEARCH]: GenericWhitelist;
  info: PatientInfoWhitelist;
  medical: PatientMedicalWhitelist;
  mental: PatientMentalWhitelist;
  mobility: PatientMobilityWhitelist;
  needs: PatientNeedsWhitelist;
  transfer: PatientTransferWhitelist;
  transport: PatientTransportWhitelist;
};

export type PatientWhitelist = {
  [stepKey in keyof PrecomputePatientWhitelist]?: {
    [valueKey in keyof PrecomputePatientWhitelist[stepKey]]: boolean;
  };
};

export type PatientWhitelistScope = {
  country?: Country;
  search_type?: SearchType;
  sender_type?: number;
  solutions?: Solutions;
  specializations?: Array<number>;
  variant?: AssessmentVariantType;
};

export type IsSealdOnly = (sessionsInContext?: {
  newSealdSession: unknown;
  oldSession: unknown;
}) => boolean;

export type ApolloEncryptionContext = {
  decrypt: boolean;
  isSealdOnly: IsSealdOnly;
  privateKey: string | undefined;
  trackEvent: TrackEventFn;
};

export type FaxResponse = {
  url: string;
};

export type AddressCircle = {
  city: string;
  coordinates: { latitude: number; longitude: number; zipcode: string };
  country: string;
  floor?: number;
  house_number: string;
  radius: number;
  street: string;
  street_number: string;
  zipcode: string;
};

export type SidebarMenuItem = {
  deactivated?: boolean;
  divider?: boolean;
  icon: any;
  id: string;
  label: string;
  onClick: () => void;
  showBadge?: boolean;
  showNotification?: boolean;
  to: To;
  tour?: TourElement;
};

export type SenderReceiverNote = {
  note: string;
};

export type ScrollPosition = {
  x: number | undefined;
  y: number | undefined;
};

export type TooltipPlacement =
  | "bottom-end"
  | "bottom-start"
  | "bottom"
  | "left-end"
  | "left-start"
  | "left"
  | "right-end"
  | "right-start"
  | "right"
  | "top-end"
  | "top-start"
  | "top"
  | undefined;

export type MedicalProductType = {
  description: string;
  id: string;
  location: number;
  name: string;
  objectID?: string;
  product_group: number;
  subgroup: number;
  type: number;
};

export type MedicalSupplies = {
  additional_information?: string;
  delivery_address?: Location;
  delivery_address_type?: number;
  prescription_issued?: boolean;
  prescription_issued_description?: string;
  products?: MedicalProductType[];
};

export type ProviderBlacklistingRule = {
  careprovider_id?: number;
  careseeker_id?: number;
  created_at?: number;
  filter_type: number;
  id?: number;
  is_whitelist?: boolean;
  product_group?: number;
  search_partial_zipcode?: string;
  specialization?: number;
};

export type ProviderBlackListing = {
  rules: ProviderBlacklistingRule[];
  scope: {
    careprovider_id: number;
    filter_type: number;
  };
};

export type CareproviderRequests = {
  remaining: number | null;
  requests: AuctionRequest[];
  total: number | null;
};

export type GetCareproviderRequestsNewPayload = {
  careproviderRequestsNew?: RequestPage;
};

export type GetCareproviderRequestsNewResponse = {
  data?: GetCareproviderRequestsNewPayload;
};

export type EncryptionJobMaterial = {
  encryption_public_key: string;
  signing_private_key?: string;
};

export type EncryptionJobRequest = {
  aes_encrypted_data: string;
  compressed: boolean;
  data_signature: string | undefined;
  encrypted_aes_secrets: string;
};

export type CareproviderDpaFile = {
  church_owned: boolean;
  file_name?: string;
  signed_at?: number;
  uploaded_at?: number;
};

export type MessengerTabKinds = (typeof ALL_MESSENGER_TABS)[number];

export type OnRefreshSearchMerge = { full_page_refresh?: boolean };

export type RefreshPredictPayload = {
  external_patient_id?: string;
  refresh_dashboard: boolean;
  refresh_patient_profile: boolean;
};

export type SealdIdentityInput = {
  account_id: number;
  datetime: string;
};

export type SealdIdentityPayload = {
  must_authenticate: boolean;
  seald_two_man_rule_key: string;
  seald_two_man_rule_session_id: string;
  seald_user_license_token: string;
};

export type AppType = ValueOf<typeof APP_KIND>;
export type AppName = ValueOf<typeof APP_VERSION_NAMES>;

export type ProviderSearch = (typeof PROVIDER_SEARCHES)[number];
export type ProviderSearchName = (typeof PROVIDER_SEARCH_VERSIONS)[number];

export type ActiveProviderSearch = (typeof ACTIVE_PROVIDER_SEARCHES)[number];
export type ActiveProviderSearchName =
  (typeof ACTIVE_PROVIDER_SEARCH_VERSIONS)[number];

export type Version = {
  __typename: string;
  application: AppName;
  id: number;
  version: string;
};

export type BrowserSubscription = PushSubscriptionJSON & {
  id_token?: string | null;
};
export type SEALD_FLOW_TYPES = (typeof SEALD_FLOWS)[number];

export type SealdIdentityCheck = {
  has_2mr: boolean;
  has_password: boolean;
  must_authenticate: boolean;
};

export type CareproviderTab =
  | typeof CAREPROVIDER_TAB_TYPE_DIRECT
  | typeof CAREPROVIDER_TAB_TYPE_ATTRIBUTED
  | typeof CAREPROVIDER_TAB_TYPE_IN_PROGRESS
  | typeof CAREPROVIDER_TAB_TYPE_NEW
  | typeof CAREPROVIDER_TAB_TYPE_OTHER;

export type CareseekerTab =
  | typeof CARESEEKER_TAB_TYPE_ARCHIVED
  | typeof CARESEEKER_TAB_TYPE_DRAFT
  | typeof CARESEEKER_TAB_TYPE_FINISHED
  | typeof CARESEEKER_TAB_TYPE_PATIENTS;

export type GenericDashboardTab = CareproviderTab | CareseekerTab;
export type GenericDashboardTabKey =
  | ValueOf<typeof CAREPROVIDER_DASHBOARD_TAB>
  | ValueOf<typeof CLINIC_TODO_DASHBOARD_TAB>;

export type FilterValueAgeInterval = DeepNullableObj<Interval>;
export type FilterValueCarelevels = number[];
export type FilterValueCareseekers = number[];
export type FilterValueGenders = number[];
export type FilterValueElective = boolean | null;
export type FilterValueSenders = { id: number; label: string; value: string }[];
export type FilterValuePatientTypes = SearchType[];
export type FilterValueSolutions = number[];
export type FilterValueSocialWorkers = number[];
export type FilterValueSpecializations = number[];
export type FilterValueStations = number[];
export type FilterValueTab = string;
export type FilterValueStartDateRange = {
  from_date: number | null;
  to_date: number | null;
} | null;
export type FilterValueServices = number[];
export type FilterValueStartDate = number;
export type FilterValueCapacity = boolean;
export type FilterValueTreatmentLocation = {
  id?: any;
  label: string;
  latitude?: number;
  longitude?: number;
  value: string;
};
export type FilterValueDistance = number;
export type FilterValueWithConsultant = boolean;
export type FilterValueWithProvider = boolean;
export type FilterValueIsDirect = boolean;
export type FilterValuePersistState = boolean;
export type FilterValuePaginationStart = number;
export type FilterValuePaginationCount = number;
export type FilterValueWeightInterval = DeepNullableObj<Interval>;
export type FilterValueTransitionalCare = boolean | null;
export type FilterValueDirectRequestTypes = number[];

export type DashboardFilterLocalStorageBaseKey =
  | typeof RECEIVER_DASHBOARD_FILTERS
  | typeof SENDER_DASHBOARD_FILTERS;

export type CapacityStatus = (typeof CAPACITY_STATUSES)[number];
export type CapacityDeclineMode =
  (typeof CAPACITY_DECLINE_MODE)[keyof typeof CAPACITY_DECLINE_MODE];

// relates to the BE status of candidates calculation
// which is now asynchronously completed on the tool server
export type CandidatesStatus = (typeof CANDIDATES_STATUS)[number];

export type SearchMergeStopSearchPanel =
  (typeof SEARCH_MERGE_STOP_SEARCH_PANELS)[number];

export type ExperimentAttribution = {
  account_id?: number;
  experiment_id?: number;
  experiment_name?: string;
  experiment_value?: string;
};

export type RequestChipStatus = (typeof REQUEST_CHIP_STATUSES)[number];

export type SearchPanelCandidate = {
  careprovider: {
    __typename: string;
    address?: {
      address?: string;
      city?: string;
      street?: string;
      street_number?: string;
      zip_code?: string;
    };
    capacity?: Capacity;
    id: number;
    inactive_reason?: number;
    name: string;
    profile?: CareproviderProfile;
    status?: CareproviderStatus;
  };
  distance: number;
  id: number;
  send_fax?: boolean;
  solutions?: number[];
};

export type SearchPanelRequest = {
  careprovider?: {
    __typename: string;
    address?: {
      address?: string;
      city?: string;
      street?: string;
      street_number?: string;
      zip_code?: string;
    };
    id: number;
    name: string;
  };
  created_at: number;
  distance: number;
  id: number;
  request_actions?: RequestActions;
  solutions?: number[];
};

export type AcceptedTableRequest = SearchPanelRequest & {
  chip_status: RequestChipStatus;
  patient_data_shared: boolean;
  patient_preferred: boolean;
  patient_preferred_reason: string;
  potential_start_date: number;
  potential_start_time: string;
};

export type AcceptedTablePayload = {
  requests?: AcceptedTableRequest[];
  total?: number;
};

export type ContactedTableRequest = SearchPanelRequest & {
  chip_status: RequestChipStatus;
  patient_data_shared: boolean;
  patient_preferred: boolean;
  patient_preferred_reason: string;
  recommendation_id?: number;
};

export type ContactedTablePayload = {
  requests?: ContactedTableRequest[];
  total?: number;
};

export type PotentialReceiversTableCandidate = SearchPanelCandidate;

export type PotentialReceiversTablePayload = {
  requests?: PotentialReceiversTableCandidate[];
  total?: number;
};

export type SolutionFilterReasons = Record<string, EventFilter[]>;

export type FilteredTableFilteredCandidate = SearchPanelCandidate & {
  recommendation_id?: number;
  send_fax?: boolean;
  solution_filter_reasons: SolutionFilterReasons;
};

export type FilteredTablePayload = {
  filtered_candidates?: FilteredTableFilteredCandidate[];
  total?: number;
};

export type RejectedTableRequest = SearchPanelRequest & {
  chip_status: RequestChipStatus;
  patient_preferred: boolean;
  patient_preferred_reason: string;
  validation: {
    rejected_at: number;
  };
};

export type RejectedTablePayload = {
  requests?: RejectedTableRequest[];
  total?: number;
};

export type DeclinedTableRequest = SearchPanelRequest & {
  chip_status: RequestChipStatus;
  patient_preferred: boolean;
  patient_preferred_reason: string;
  response: {
    capacity_date?: number;
    declined_at: number;
    declined_reason?: number;
    message?: string | null;
    no_capacity_expiration?: number;
    no_capacity_reasons?: Array<NoCapacityReason> | undefined;
  };
};

export type DeclinedTablePayload = {
  requests?: DeclinedTableRequest[];
  total?: number;
};

export type ValidatedTableRequest = SearchPanelRequest & {
  chip_status: RequestChipStatus;
  patient_data_shared: boolean;
  patient_preferred: boolean;
  patient_preferred_reason: string;
};

export type ValidatedTablePayload = {
  request?: ValidatedTableRequest;
  total?: undefined;
};

export type SearchTable = (typeof SEARCH_TABLE_TABLES)[number];
export type TableCount = (typeof SEARCH_TABLE_ROW_COUNTS)[number];
export type TableSortValue = keyof typeof SORTING_MAP;
export type ActiveSearchMergeStatus =
  (typeof ACTIVE_SEARCH_MERGE_STATUSES)[number];
export type SearchMergeStatus = (typeof SEARCH_MERGE_STATUSES)[number];

export type AuctionStepperStepNumber = (typeof AUCTION_STEPPER_STEPS)[number];

export type TablePageState = {
  count: TableCount;
  page: number;
  sortBy: TableSortValue;
};

export type SearchTablePagination = {
  [index in SearchTable]: TablePageState;
};

export type TablePayload = (typeof TABLES_PAYLOAD)[number];

export type SearchMergePayload = {
  [TABLE_PAYLOAD_ACCEPTED]: AcceptedTablePayload;
  [TABLE_PAYLOAD_CONTACTED]: ContactedTablePayload;
  [TABLE_PAYLOAD_DECLINED]: DeclinedTablePayload;
  [TABLE_PAYLOAD_FILTERED]: FilteredTablePayload;
  [TABLE_PAYLOAD_POTENTIAL]: PotentialReceiversTablePayload;
  [TABLE_PAYLOAD_REJECTED]: RejectedTablePayload;
  [TABLE_PAYLOAD_VALIDATED]: ValidatedTablePayload;
  context: {
    search_merge_banners: SearchMergeBanner[];
    search_merge_status: SearchMergeStatus | undefined;
  };
};

export type SearchTableTotals = { [key in TablePayload]?: number };

export type SearchMergeTableRequest =
  | AcceptedTableRequest
  | ContactedTableRequest
  | DeclinedTableRequest
  | FilteredTableFilteredCandidate
  | PotentialReceiversTableCandidate
  | RejectedTableRequest;

export type CyFeatureFlagKey =
  | "activateArhV2"
  | "activateReactHookForm"
  | "activateSelectableProviders"
  | "activateWebSocket"
  | "activateSalesforceChat"
  | "activateNewFormDesign";

export type CyFeatureFlags = Partial<Record<CyFeatureFlagKey, boolean>>;

export type ProductTourCompletion = {
  completed: boolean | null;
  product_tour_id: number;
};

export type RadioOption = {
  disabled?: boolean;
  id: number | string;
  label: string;
  subForm?: React.ReactNode;
  value: number;
};

export type IndexDbSessionKeysDB = typeof INDEX_DB_SESSION_KEYS;
export type IndexDbSessionKeysDBVersion = typeof INDEX_DB_SESSION_KEYS_VERSION;
export type IndexDbSessionKeysTableName = (typeof INDEX_DB_TABLES)[number];

export type AssessmentSlug = ValueOf<typeof ASSESSMENT_SLUG>;

export type MUIPickersDate = Date | null;

export type WebSocketStatus = keyof typeof WEBSOCKET_STATUS;

export type SearchType = ValueOf<typeof SEARCH_TYPES>;

export type AvailableSearchTypes = {
  __typename: string;
  search_types: number[];
};

export type SearchMergeBanner = (typeof SEARCH_MERGE_BANNERS)[number];

export type OnpremPatient = {
  admit_date_time?: number;
  allergies?: string;
  anamnesis?: string;
  attending_doctor?: OnpremDoctor;
  barthel_assessment?: BarthelAssessment;
  birth_date?: string;
  care_level?: string;
  consulting_doctor?: OnpremDoctor;
  discharge_date_time?: number;
  early_rehab_assessment?: EarlyRehabAssessment;
  evolution?: string;
  expected_admit_date_time?: number;
  expected_discharge_date_time?: number;
  external_id?: string;
  first_name?: string;
  gender?: number;
  guardians?: Array<OnpremNextOfKin>;
  height?: string;
  hospital_id?: string;
  infections?: string;
  insurance?: {
    insurance_company_name?: string;
    insurance_id_number?: string;
    insurance_ik_number?: string;
  };
  last_messages_v2?: Array<string>;
  last_name?: string;
  location?: {
    city: string;
    postal_code: string;
    street_address: string;
  };
  main_diagnoses?: Array<OnpremDiagnosis>;
  medical_history?: string;
  medical_instructions?: string;
  patient_contact?: PatientIsContact;
  personal_id?: string; // not implemented
  recommended_routine?: string;
  relatives?: Array<OnpremNextOfKin>;
  secondary_diagnoses?: Array<OnpremDiagnosis>;
  singer_assessment?: SingerAssessment;
  station?: string;
  weight?: string;
};

export type PatientIsContact = {
  email: string;
  home_address: {
    city?: string;
    postal_code?: string;
    street_address?: string;
  };
  phone_number: string;
};

export type OnpremDoctor = {
  address_city?: string;
  address_postal_code?: string;
  address_street?: string;
  degree?: string | null;
  discipline?: string;
  doctorType?: string;
  first_name?: string;
  last_name?: string;
  phone_number?: string;
  phone_prefix?: string;
  prefix?: string;
};

export type OnpremDiagnosis = {
  diagnosis_code?: string;
  diagnosis_codesystem_version?: string;
  diagnosis_description?: string;
  diagnosis_id?: number;
  diagnosis_type?: string;
};

export type OnpremNextOfKin = {
  address_city?: string;
  address_postal_code?: string;
  address_street?: string;
  first_name?: string;
  last_name?: string;
  phone_number?: string;
  relationship?: string;
};

export type AlgoliaAnalyticsName = (typeof ALGOLIA_ANALYTICS_NAMES)[number];
export type AlgoliaIndex = ValueOf<typeof ALGOLIA_INDICES>;
/**
 * Options produced from Algolia hits. `id` and `value` should stay aligned so
 * `selectedKey` / selection callbacks stay stable.
 */
export type AlgoliaAutocompleteOption = WithId & {
  label: string;
  value: string;
};

export type InsuranceAlgoliaOption = AlgoliaAutocompleteOption & {
  careseekerId?: string;
  is_active?: boolean;
};

export type ICDAlgoliaOption = AlgoliaAutocompleteOption & {
  code: string;
  description: string;
};

/**
 * Algolia hit from `searchClient.search` or InstantSearch (includes `objectID`, `_highlightResult`).
 * Same pattern as {@link InsuranceSearchBar}'s `Hit<Insurance>` and `CareproviderHit`.
 */
export type AlgoliaSearchResult<
  T extends Record<string, unknown> = Record<string, unknown>,
> = Hit<T>;

/** `insurances` index record (string ids in search responses). */
export type InsuranceAlgoliaRecord = {
  careseeker_id?: string;
  id?: string;
  is_active?: boolean;
  name?: string;
};

export type InsuranceAlgoliaHit = Hit<InsuranceAlgoliaRecord>;

/** `icd_codes` index — record shape matches {@link IcdCode}. */
export type ICDAlgoliaHit = Hit<IcdCode>;

export type SealdSessionAccess = {
  id: number | null;
  name: string | null;
  pending_access_created_at: number | null;
  seald_access: boolean | null;
  seald_access_created_at: number | null;
  seald_db_access_created_at: number | null;
};

export type SealdSessionsPayload = {
  account_accesses: Array<SealdSessionAccess> | null;
  careprovider_accesses: Array<SealdSessionAccess> | null;
  careseeker_accesses: Array<SealdSessionAccess> | null;
  seald_encryption_context_created_at: number | null;
};

export type ProviderSearchAuction = {
  id?: number;
  profile?: Pick<AuctionProfile, "search_location">;
  solutions: Auction["solutions"];
  start_date: Auction["start_date"] | null;
};

export type ProviderSearchPatient = {
  active_requests?: { careprovider_id: number; id: number }[];
  archived?: boolean;
  archived_at?: number;
  care_needs: Pick<
    PatientNeeds,
    | "basic_medical_care"
    | "base_care"
    | "psychiatric_care"
    | "palliative"
    | "breathing"
    | "static_care_disabled_patients"
    | "care_for_children_and_teenagers"
    | "care_for_youth"
  >;
  diagnosis: {
    mental_health?: Pick<
      MentalHealth,
      "dementia" | "dementia_description" | "protected_area_needed"
    >;
  };
  id: number;
  profile?: Pick<
    PatientProfile,
    "age_interval" | "gender" | "care_duration_in_days" | "weight_interval"
  > & {
    financing?: Pick<Financing, "carelevel">;
  };
  profile_id: number;
  seald_encryption_context?: Patient["seald_encryption_context"];
  services?: number[];
  user_id?: Patient["user_id"];
};

export type ProviderSearchPatients = {
  active: ProviderSearchPatient[];
  archived: Omit<ProviderSearchPatient, "active_requests">[];
};

export type ProviderSearchProviderProfile = Pick<
  CareproviderProfile,
  | "accepted_age"
  | "accepted_weight"
  | "supported_health_insurance_types"
  | "languages"
  | "caregiver_genders"
  | "room_types"
  | "whitelisted_zipcodes"
  | "radius_in_meter"
> | null;

export type ProviderSearchProvider = {
  __typename?: string;
  address: CareproviderAddress;
  capacity?: Capacity;
  central_email?: string;
  central_phone_number?: string;
  cover_image_file?: Pick<CareproviderFile, "url" | "file_name">;
  distance: number;
  facilities?: number[] | null;
  id: number;
  is_consultant: boolean;
  name: string;
  opening_hours?: OpeningHours;
  other_remarks?: string;
  profile?: ProviderSearchProviderProfile;
  project_sponsor?: string;
  services?: number[] | null;
  website?: string;
};

export type ProviderSearchActivation = {
  account: Account;
  auth_result: {
    account_id: string;
    id_token: string;
  };
  seald_two_man_rule_session_id: string;
};

export type LogoColors = (typeof LOGO_COLOR_SCHEMA)[number];

export type ProviderSearchListing = {
  cards?: Array<ProviderListing>;
  remaining: number;
  total: number;
};

export type ProviderSearchOverviewRequest = {
  action_required_by_user?: AuctionRequest["action_required_by_user"];
  auction?: Pick<
    Auction,
    "last_status_change" | "created_at" | "start_date" | "id"
  >;
  careprovider?: Pick<Careprovider, "address" | "name" | "id">;
  created_at?: AuctionRequest["created_at"];
  id: number;
  response?: Pick<AuctionResponse, "updated_at">;
  solutions?: AuctionRequest["solutions"];
  status?: AuctionRequest["status"];
  validation?: Pick<AuctionValidation, "updated_at">;
};

export type ProviderSearchRequestsOverview = {
  active: {
    requests: ProviderSearchOverviewRequest[] | undefined;
  } | null;
  inactive: {
    requests: ProviderSearchOverviewRequest[] | undefined;
  } | null;
  validated: {
    requests: ProviderSearchOverviewRequest[] | undefined;
  } | null;
};

export type PaginationResultCount = (typeof PAGINATION_RESULT_COUNTS)[number];

export type AgeRange = { max: number | null; min: number | null; name: string };

export type ConsultantStatus = (typeof CONSULTANT_STATUSES)[number];

export type Consultant = {
  address: CareproviderAddress;
  central_email?: string;
  central_phone_number?: string;
  description?: string;
  id: number;
  name: string;
  opening_hours?: OpeningHours;
  project_sponsor?: string;
  status?: ConsultantStatus;
  website?: string;
};

export type WeekDay = ValueOf<typeof WEEKDAYS>;

export type OpeningHours = {
  [index in WeekDay]?: string | null;
} & {
  __typename?: "OpeningHours";
};

export type ConsultantEvent = {
  account: Account;
  context: {
    diff: string[];
  };
  id: number;
  timestamp: number;
  type: (typeof CONSULTANT_EVENTS)[number];
};

export type ConsultantEventPage = {
  events: ConsultantEvent[];
  remaining: number;
  total: number;
};

export type LegalDocument = {
  needs_to_sign?: boolean;
  signed_at?: number;
  url: string;
  version?: string;
};

export type LegalDocumentType = (typeof LEGAL_DOCUMENTS)[number];

export type LegalDocuments = Record<LegalDocumentType, LegalDocument | null> & {
  __typename: "LegalDocuments";
};

export type GlossarySection = (typeof GLOSSARY_SECTIONS)[number];

export type RedirectReason =
  | typeof REDIRECT_REASON_GENERIC_ERROR
  | typeof REDIRECT_REASON_LINK_EXPIRED
  | typeof REDIRECT_REASON_NOT_AUTHORIZED;

export type TourElement =
  | Record<string, never>
  | {
      "data-tour-id": string;
      "data-tour-step": number;
    };

export type { IntroStep } from "intro.js/src/core/steps";
export type { Options as IntroOptions } from "intro.js/src/option";

export type TransitionalCareImportedAuctionRequest = {
  careprovider: {
    address: {
      address: string;
      city: string;
      zip_code: string;
    };
    id: number;
    name: string;
  };
  created_at: number;
  id: number;
  request_status: number;
};

export type GetAccountsForCareseekerPayload = {
  getAccountsForCareseeker: {
    accounts: Account[];
    active_user_manager_accounts_count: number;
    total_accounts: number;
    total_filtered_accounts: number;
  };
};

export type GetAccountsForCareproviderPayload = {
  getAccountsForCareprovider: {
    accounts: Account[];
    total_accounts: number;
    total_filtered_accounts: number;
  };
};

export type GetAccountsForCareseekerQueryString =
  `search_term=${string}&start=${number}&count=${number}&sort_field=${string}&sort_order=${SortOrder}`;

export type GetAccountsForCareseekerVariables = {
  careseekerId: number;
  filters: GetAccountsForCareseekerQueryString;
};

export type GetAccountsForCareproviderVariables = {
  careproviderId: number;
  filters: GetAccountsForCareseekerQueryString;
};

export type ProductFeatureStatus = ValueOf<typeof PRODUCT_FEATURE_STATUSES>;
export type ProductFeatureType = ValueOf<typeof PRODUCT_FEATURES>;

export type ProductFeature = {
  __typename?: string;
  expiration_date?: number;
  feature: ProductFeatureType;
  id?: number;
  start_date?: number;
  status: ProductFeatureStatus;
};

export type ProductFeatureRequestPayload = ProductFeature;

export type ProductFeatureDependency = {
  configPath: string;
  isActive: boolean;
  label: string;
  description?: string;
};

export type ProductFeatureSubFeature = {
  key: string;
  isActive: boolean;
  label: string;
  description?: string;
};

export type RequestSentTime =
  | {
      hour: number;
      millisecond: number;
      minute: number;
      second: number;
    }
  | number
  | null;

export type TransitionalCareRequest = {
  [REQUEST_FORM_FIELDS.CAREPROVIDER_ADDRESS_ADDRESS]: string;
  [REQUEST_FORM_FIELDS.CAREPROVIDER_ADDRESS_CITY]: string;
  [REQUEST_FORM_FIELDS.CAREPROVIDER_ADDRESS_ZIPCODE]: string;
  [REQUEST_FORM_FIELDS.CAREPROVIDER_NAME]: string;
  [REQUEST_FORM_FIELDS.REQUEST_SENT_DATE]: number | null;
  [REQUEST_FORM_FIELDS.REQUEST_SENT_TIME]: RequestSentTime;
  [REQUEST_FORM_FIELDS.REQUEST_STATUS]: number | Array<number> | null;
  edited: boolean;
  id: number;
  manual: boolean;
  request_id: number | null;
};

export type TransitionalCareFormData = {
  aftercare_application_date?: number;
  aftercare_application_explanation?: string;
  aftercare_application_submitted?: boolean;
  aftercare_care_level_aftercare_required?: boolean;
  aftercare_care_level_applied?: boolean;
  aftercare_care_level_applied_date?: number;
  aftercare_care_level_available?: boolean;
  aftercare_care_level_explanation?: string;
  aftercare_medical_rehab?: boolean;
  aftercare_mobile?: boolean;
  aftercare_shortterm_care?: boolean;
  aftercare_start_date?: number;
  care_necessity?: number;
  clinic_ik_number?: string;
  clinic_location_city?: string;
  clinic_location_street?: string;
  clinic_location_street_number?: string;
  clinic_location_zipcode?: string;
  clinic_name?: string;
  handover_to_insurance_date?: number;
  insurance_form_sent_date?: number;
  internet_portal_used?: boolean | PredicamentYesNo;
  legal_representative_consent_provided?: boolean;
  legal_representative_first_name?: string;
  legal_representative_last_name?: string;
  legal_representative_location_city?: string;
  legal_representative_location_street?: string;
  legal_representative_location_street_number?: string;
  legal_representative_location_zipcode?: string;
  patient_date_of_birth?: number;
  patient_first_name?: string;
  patient_insurance_number?: string;
  patient_last_name?: string;
  patient_location_city?: string;
  patient_location_house_number?: string;
  patient_location_street?: string;
  patient_location_zipcode?: string;
  prior_treatment_end_date?: number;
  prior_treatment_hospital_id?: string;
  prior_treatment_start_date?: number;
  request_list?: TransitionalCareRequest[];
  social_worker_email?: string;
  social_worker_fax?: string;
  social_worker_first_name?: string;
  social_worker_last_name?: string;
  social_worker_telephone?: string;
  transitional_care_department_code?: string;
  transitional_care_description?: string;
  transitional_care_end_date?: number;
  transitional_care_location_id?: string;
  transitional_care_patient_confirmation?: boolean;
  transitional_care_patient_confirmation_date?: number;
  transitional_care_patient_confirmation_explanation?: string;
  transitional_care_start_date?: number;
  transitional_care_start_search_date?: number;
  transitional_care_suitable_providers_count?: number;
  transitional_care_suitable_providers_more_than_twenty?: boolean;
};

export type TokenInvalidReason = ValueOf<typeof TOKEN_INVALID_REASONS>;

export type A11yStatusUpdate = { message: string; role: "status" | "alert" };

export type CareproviderStatus = (typeof CAREPROVIDER_STATUSES)[number];

export type RehabFormName = ValueOf<typeof REHAB_FORM_NAMES>;
export type RehabFormPath = (typeof REHAB_FORM_PATHS)[number];
export type RehabFormFileName = (typeof REHAB_FORM_FILE_NAMES)[number];
export type DocsFormPath = ValueOf<typeof FORM_PDF_PATHS>;
export type DocsFormFileName = ValueOf<typeof FORM_DOWNLOADED_PDF_NAMES>;
export type PatientDocumentType = ValueOf<typeof PATIENT_DOCUMENTS>;

export type EarlyRehabBarthelCriteria =
  (typeof EARLY_REHAB_CRITERIA)[keyof typeof EARLY_REHAB_CRITERIA];

export type Guardian = ValueOf<typeof GUARDIAN>;
export type HomeCareSituation = ValueOf<typeof HOME_CARE_SITUATION>;
export type AtHomeSituation = ValueOf<typeof AT_HOME_SITUATION>;
export type MuskuloskeletalResilience = ValueOf<
  typeof MUSCOSKELETAL_RESILIENCE
>;
export type EarlyRehabCriteria = ValueOf<typeof EARLY_REHAB_CRITERIA>;
export type RehabDirectiveType = ValueOf<typeof REHAB_DIRECTIVE_TYPE>;
export type RehabFocus = ValueOf<typeof REHAB_FOCUS>;
export type TransportType = ValueOf<typeof TRANSPORTATION_TYPE>;
export type TransportSubtype = ValueOf<typeof TRANSPORTATION_SUBTYPE>;
export type ApprovedByType = ValueOf<typeof DTA_MEDICAL_FORM_APPROVED_BY>;

export type LivingSituation = ValueOf<typeof LIVING_SITUATIONS>;
export type YesNoFieldOption = ValueOf<typeof YES_NO_FIELD_OPTIONS>;

export type PredicamentState = (typeof PREDICAMENT_STATES)[number];
export type PredicamentYes = typeof PREDICAMENT_STATE_YES;
export type PredicamentYesNo = [
  typeof PREDICAMENT_STATE_YES,
  typeof PREDICAMENT_STATE_NO,
][number];
export type PredicamentYesNoUnknown =
  (typeof PREDICAMENT_YES_NO_UNKNOWN)[number];
export type Gender = ValueOf<typeof GENDER>;
export type PatientTransportType = (typeof TRANSPORT_TYPE_ASSESSMENT)[number];

export type RehabAdmission = ValueOf<typeof REHAB_ADMISSION>;
export type TypeOfRehab = ValueOf<typeof TYPE_OF_REHAB>;
export type RehabTriggeringEvent = ValueOf<typeof REHAB_TRIGGERING_EVENT>;
export type OutPatientNotPossibleReason = ValueOf<
  typeof OUTPATIENT_NOT_POSSIBLE_REASONS
>;

export type PriorEmploymentStatus = ValueOf<typeof PRIOR_EMPLOYMENT_STATUS>;
export type HealthInsuranceType = ValueOf<typeof HEALTH_INSURANCE_TYPES>;
export type MaritalStatus = ValueOf<typeof MARITAL_STATUS>;
export type DrvTransportType = ValueOf<typeof DRV_TRAVEL_TYPES>;
export type LegalGuardian = ValueOf<typeof LEGAL_GUARDIAN>;
export type LackOfCapacity = ValueOf<typeof LACK_OF_CAPACITY_DOCUMENT>;
export type VisuallyImpairedDocument = ValueOf<
  typeof VISUALLY_IMPAIRED_DOCUMENT
>;
export type EmploymentStatus = (typeof EMPLOYMENT_STATUS)[number];

export type RequestedRehaService = ValueOf<typeof REQUESTED_REHAB_SERVICE>;
export type RequestedRehaServiceType = ValueOf<
  typeof REQUESTED_REHAB_SERVICE_TYPE
>;

export type NotificationType = ValueOf<typeof NOTIFICATION_TYPES>;
export type CareLevelFormType = ValueOf<typeof CARE_LEVEL_FORMS>;

export type ChatListItem = {
  __typename?: string;
  id: number;
  title: EncryptedField | null;
  seald_encryption_context?: EncryptionContext | null;
  updated_at: number;
};

export type Chat = ChatListItem & {
  messages: EncryptedField;
  seald_encryption_context?: EncryptionContext;
};
export type BedrockAudioRecording = {
  form_type: CareLevelFormType;
  id: number;
  label?: string;
  link: string;
  name: string;
  transcript: string;
};

export type BedrockPrompt = {
  id: number;
  name: string;
  prompt: string;
};

export type BedrockSchema = {
  form_type: CareLevelFormType;
  id: number;
  json_schema: string;
  name: string;
};

export type BedrockExample = {
  example_response: string;
  example_transcript: string;
  form_type: CareLevelFormType;
  id: number;
  name: string;
};

export type BedrockModelConfig = {
  max_tokens: number;
  model_id: string;
  temperature: number;
  top_k: number;
  top_p: number;
};

export type BedrockResponse = {
  audio_recording: BedrockAudioRecording;
  audio_recording_id: number;
  example: BedrockExample;
  example_id: number;
  form_type: CareLevelFormType;
  id: number;
  model_config: BedrockModelConfig;
  prompt: BedrockSchema;
  prompt_id: number;
  response: string;
  schema: BedrockSchema;
  schema_id: number;
};

export type BedrockResponsePayload = Omit<
  BedrockResponse,
  "example" | "prompt" | "schema" | "id" | "audio_recording"
>;

export type BedrockPromptRequest = BedrockModelConfig & {
  prompt: string;
};

export type BedrockTranscribeRequest = {
  s3_uri?: string;
};

export type BedrockPlaygroundPage = {
  audio_recordings: BedrockAudioRecording[];
  examples: BedrockExample[];
  prompts: BedrockPrompt[];
  responses: BedrockResponse[];
  schemas: BedrockSchema[];
};

export type LostSessionsCount = {
  active_files: number;
  active_patients: number;
  active_requests: number;
  archived: number;
};

export type GroupSessionsResponse = {
  lost_sessions: LostSessionsCount;
  pending_seald_access_count: number;
};

export type SsoTokenDecoded = {
  exp: number;
  jti: string;
  sub: string;
};

export type RateLimitError = {
  __typename: "RateLimit";
  expires_at: number;
  remaining_time: number;
};

export type RateLimitErrorResponse = {
  body: RateLimitError;
  status: 429;
};

export type PredictTrend = ValueOf<typeof PREDICT_TREND>;
export type PredictAssignee = {
  account_id: number;
  created_at: string;
  first_name: string;
  last_name: string;
  updated_at: string;
};

export type PredictPatientStatusValue = ValueOf<typeof PREDICT_PATIENT_STATUS>;

export type PredictStatusHistoryEntry = {
  account_id: number;
  changed_at: string;
  status: PredictPatientStatusValue;
};

export type PredictPatientStatusPayload = {
  created_at?: string;
  history?: PredictStatusHistoryEntry[];
  status: PredictPatientStatusValue;
  updated_at?: string;
};

export type PredictFeedback = {
  agree: boolean;
  probability: number;
  timestamp: number;
};

export type PatientApiResponse = {
  admit_date_time?: number;
  barthel_index?: string;
  birth_date: string;
  bookmarked_account_ids?: number[];
  care_level?: number | null;
  discharge_probability: number;
  external_id: string;
  first_name: string;
  gender?: number;
  insurance?: {
    insurance_company_name: string;
    insurance_id_number: string;
    insurance_ik_number: string;
  };
  last_name: string;
  length_of_stay?: { average_duration: number };
  location?: {
    city: string;
    postal_code: string;
    street_address: string;
  };
  main_diagnoses?: {
    diagnosis_code: string;
    diagnosis_codesystem_version: string;
    diagnosis_description: string;
    diagnosis_id: string;
    diagnosis_type: string;
  }[];
  predict_feedbacks?: PredictFeedback[];
  predict_trend: PredictTrend;
  secondary_diagnoses?: {
    diagnosis_code: string;
    diagnosis_codesystem_version: string;
    diagnosis_description: string;
    diagnosis_id: string;
    diagnosis_type: string;
  }[];
  assignee?: PredictAssignee | null;
  patient_status?: PredictPatientStatusPayload | null;
  station?: string;
  status?: string | null;
};

export type PredictPatient = {
  address: string;
  admissionDate: number | undefined;
  age: number | null;
  assignee?: PredictAssignee | null;
  barthelIndex: number | null;
  birthDate: string;
  bookmarked_account_ids?: number[];
  careLevel: number | null;
  diagnosis: string | null;
  diagnosisDescription: string | null;
  dischargeProbability: number | null;
  dischargeProbabilityRaw: number | null;
  gender?: number;
  healthInsurance?: string;
  healthInsuranceNumber?: string;
  id: string;
  lastFeedback: PredictFeedback | null;
  isAdmissionToday: boolean;
  lengthOfStay: number | null;
  patient_status: PredictPatientStatusPayload;
  patientName: string;
  predict_trend: PredictTrend;
  secondaryDiagnosis: string | null;
  station: string;
  status?: string | null;
};

export type LinkType = { href?: never; to: To } | { href: string; to?: never };

export type PredictActionType = ValueOf<typeof PREDICT_ACTIONS>;

export type BackendErrorCode = keyof Translations["general"]["errorCodes"];

export type NotifyAction = ValueOf<typeof ACTIONS>;

export type EmbedCookielessSessionAcquireResponse = {
  api_token: string;
  api_token_ttl: number;
  authentication_token: string;
  authentication_token_ttl: number;
  navigation_token: string;
  navigation_token_ttl: number;
  session_reference_token_ttl: number;
};

export type AdmissionsFormType = ValueOf<typeof ADMISSIONS_FORM_TYPES>;

export type AdmissionFormStatus = ValueOf<typeof ADMISSIONS_FORM_STATUS>;

export type CareproviderAdmissionPage = {
  form_type: AdmissionsFormType;
  id: number;
  logo: CareproviderFile;
  careprovider: Pick<
    Careprovider,
    "id" | "address" | "facilities" | "name" | "profile"
  >;
};

export type AdmissionsActivation = {
  account: Account;
  auth_result: {
    account_id: string;
    id_token: string;
  };
  seald_two_man_rule_session_id: string;
};

/**
 * Response from admissions account/create/test (login link) endpoint.
 * Backend returns this shape only; see matching api/apimodel.TestLink and
 * admissionhandler.testCreateLink.
 */
export type AdmissionsLoginLinkResponse = { link: string };

export type CareseekerType = ValueOf<typeof CARESEEKER_TYPE>;
export type AdmissionsModal = ValueOf<typeof ADMISSIONS_MODALS>;
export type CareproviderStaticCareSolution = ValueOf<
  typeof ADMISSIONS_FORM_SOLUTIONS
>;

export type Admissions = {
  admission_form_id?: CareproviderAdmissionPage["id"];
  profile?: AdmissionsProfile;
  step?: AdmissionsStep;
  agreed_at?: number;
};

export type AdmissionsProfile = {
  care_frequency?: CareFrequency;
  care_frequency_other?: EncryptedField | null;
  current_care_types?: CurrentCareBaseType[];
  current_care_facility_types?: CurrentCareFacilityType[];
  current_care_facility_other?: EncryptedField | null;
  has_infection?: PredicamentState;
  insurance_type?: HealthInsuranceType;
  insurance_other?: EncryptedField | null;
  is_patient_main_contact?: boolean;
  main_contact_first_name?: EncryptedField | null;
  main_contact_last_name?: EncryptedField | null;
  main_contact_phone?: EncryptedField | null;
  mental_ability?: MentalAbility;
  mobility?: Mobility[];
  preexisting_conditions?: EncryptedField | null;
  referral_sources?: ReferralSource[];
  referral_sources_other?: EncryptedField | null;
  relationship_other?: EncryptedField | null;
  relationship_to_patient?: RelationshipToPatient;
  required_care_basic_types?: RequiredCareBasicTypes[];
  required_care_other?: EncryptedField | null;
  required_care_types?: RequiredCareTypes[];
  search_reason?: SearchReason;
  search_reason_other?: EncryptedField | null;
  special_care_needs?: SpecialCareNeeds[];
  special_care_needs_other?: EncryptedField | null;
  visit_times?: VisitTime[];
  visit_times_other?: EncryptedField | null;
};

export type SSOIntegrationsRight = {
  __typename: string;
  careseeker: {
    __typename: string;
    id: number;
    name: string;
  };
  has_admin_rights: boolean;
  sso_integration_id: number;
  with_consent: boolean;
};

export type ChatMessageRole = ValueOf<typeof CHAT_MESSAGE_ROLES>;

export type ChatMessage = {
  content: string;
  id: string;
  /** Model reasoning / thinking text for this assistant turn (optional, persisted in chat JSON). */
  reasoning?: string;
  role: ChatMessageRole;
  /**
   * Optional inline transcript chrome (e.g. specialist handoff badge). Opaque to the agent;
   * persisted in encrypted chat JSON when present.
   */
  transcriptDecoration?: ValueOf<typeof AG_UI_TRANSCRIPT_DECORATION>;
  timestamp: number;
};

export type RelationshipToPatient = ValueOf<typeof RELATIONSHIP_TO_PATIENT>;
export type RequiredCareTypes = ValueOf<typeof REQUIRED_CARE_TYPES>;
export type RequiredCareBasicTypes = ValueOf<typeof REQUIRED_CARE_BASIC_TYPES>;
export type CurrentCareBaseType = ValueOf<typeof CURRENT_CARE_BASE_TYPES>;
export type CurrentCareFacilityType = ValueOf<
  typeof CURRENT_CARE_FACILITY_TYPES
>;
export type CareLevelApplicationType = ValueOf<
  typeof ADMISSIONS_CARE_LEVEL_APPLICATION
>;
export type CareFrequency = ValueOf<typeof CARE_FREQUENCY>;
export type VisitTime = ValueOf<typeof VISIT_TIME>;
export type SearchReason = ValueOf<typeof SEARCH_REASON>;
export type ReferralSource = ValueOf<typeof REFERRAL_SOURCE>;
export type Mobility = ValueOf<typeof MOBILITY>;
export type MentalAbility = ValueOf<typeof MENTAL_ABILITY>;
export type SpecialCareNeeds = ValueOf<typeof SPECIAL_CARE_NEEDS>;
export type ZodValidationIssue = Omit<IssueData, "code">;

export type AnalyticsSection = ValueOf<typeof ANALYTICS_SECTIONS>;

export type AdmissionsStep = ValueOf<typeof ADMISSIONS_STEPS>;
export type AdmissionsActionScreen = ValueOf<typeof ADMISSIONS_ACTION_SCREENS>;
export type AdmissionsInfoScreen = ValueOf<typeof ADMISSIONS_INFO_SCREENS>;

export type CreatePatientRole = (typeof CREATE_PATIENT_ROLES)[number];

export type CareForChildrenAndTeenagers = {
  description?: string;
};

export type CareForYouth = {
  description?: string;
};

export type ProviderSearchPage = ValueOf<typeof PROVIDER_SEARCH_PAGES>;

export type FunctionDiagnosisPriority = ValueOf<
  typeof FUNCTION_DIAGNOSIS_PRIORITIES
>;

export type DischargeLetterENTFormData = {
  additional_diagnostic_findings?: string;
  admission_medications?: string;
  anamnesis?: string;
  clinical_course?: string;
  diagnoses?: string;
  discharge_medications?: string;
  parameters?: string;
  laboratory_parameters?: string;
  recommendations?: string;
  therapy?: string;
};

export type DischargeLetterCardiologyFormData = {
  additional_diagnostic_findings?: string;
  admission_medications?: string;
  allergies?: string;
  anamnesis?: string;
  appointments?: string;
  diagnoses?: string;
  discharge_medications?: string;
  ecg?: string;
  parameters?: string;
  lab_results?: string;
  laboratory_parameters?: string;
  physical_status?: string;
  recommendations?: string;
  social_anamnesis?: string;
  therapy_and_course?: string;
};

export type DischargeLetterObstetricsFormData = {
  anamnesis?: string;
  course_of_labor?: string;
  diagnoses?: string;
  discharge_medications?: string;
  discharge_status?: string;
  discharge_summary?: string;
  information_newborn?: string;
  lab_results?: string;
  physical_status?: string;
  postpartum_recovery?: string;
  recommendations?: string;
};

export type DischargeLetterAccidentSurgeryFormData = {
  physical_status?: string;
  allergies?: string;
  anamnesis?: string;
  appointments?: string;
  recommendations?: string;
  ecg?: string;
  additional_diagnostic_findings?: string;
  lab_results?: string;
  diagnoses?: string;
  discharge_medications?: string;
  parameters?: string;
  clinical_course?: string;
  social_anamnesis?: string;
  therapy?: string;
};

export type DischargeLetterNeurosurgeryFormData = {
  physical_status?: string;
  admission_medications?: string;
  allergies?: string;
  anamnesis?: string;
  appointments?: string;
  clinical_course?: string;
  diagnoses?: string;
  discharge_medications?: string;
  ecg?: string;
  parameters?: string;
  additional_diagnostic_findings?: string;
  lab_results?: string;
  laboratory_parameters?: string;
  recommendations?: string;
  social_anamnesis?: string;
  therapy?: string;
};

export type DischargeLetterSurgeryFormData = {
  anamnesis?: string;
  appointments?: string;
  allergies?: string;
  physical_status?: string;
  diagnoses?: string;
  recommendation?: string;
  ecg?: string;
  social_anamnesis?: string;
  lab_results?: string;
  additional_diagnostic_findings?: string;
  parameters?: string;
  clinical_course?: string;
  therapy?: string;
  discharge_medications?: string;
};

export type ExtractOCRResult = {
  message: string;
  document_id: string;
};

export type ExtractOCRStatus = ValueOf<typeof EXTRACT_OCR_STATUS>;

export type ExtractOCRStatusResult = {
  document_id: string;
  hospital_id: number;
  recare_file_id: number;
  kis_file_id: string;
  filename: string;
  case_id: string;
  kdl_code: string;
  status: ExtractOCRStatus;
  status_updated_at: number;
  source_document_uri: string | null;
  processed_document_uri: string | null;
  error_message: string | null;
  source: SourceDocumentSource;
  uploaded_at: number | null;
};

export type ExtractOCRStatusResponse = {
  documents: ExtractOCRStatusResult[];
};

export type DocsFormStatus = ValueOf<typeof DOCS_FORM_STATUS>;

export type BoundingBox = {
  x0: number;
  y0: number;
  x1: number;
  y1: number;
};

export type SourceDocumentRegion = {
  page_number: number;
  bbox: BoundingBox;
};

export type DocsFormSourceDocument = {
  id: string;
  filename: string;
  is_deleted: boolean;
  recare_file_id: number | null;
  kis_file_id: string | null;
  source: SourceDocumentSource;
  url: string;
  uploaded_at?: number | null;
  regions?: SourceDocumentRegion[];
  source_document_uri?: string | null;
};

export type DocsFormStatusResponse = {
  // TODO: should type this better to include actual form values derived from form type
  form: Record<
    string,
    {
      value: string | null;
      source_documents: DocsFormSourceDocument[] | undefined;
      contradictions: Contradictions | undefined;
    }
  >;
  status: DocsFormStatus;
  requested_at: number;
  status_updated_at: number;
  processed_at: number;
  error_message: string;
  form_stats?: {
    total_fields?: number;
    filled_fields: number;
    new_source_documents?: {
      id: number;
      filename: string;
      file_id: string;
    };
  };
};

export type AIFormName = ValueOf<typeof AI_FORM_NAME>;

export type DocsFormStartResponse = {
  message: string;
  form_id: AIFormName;
};

export type DocsFormName = ValueOf<typeof DOCS_FORM_NAMES>;

export type TrackEventProps = Record<string, string | undefined> & {
  /**
   * ID to identify the event for tracking purposes.
   * used when the id attached to the element is needed to be deduplicated, i.e. `element_id_${index}` for example
   * we use this to make sure the tracking name is consistent for BI.
   */
  id?: string;
};

export type FieldCreationType = ValueOf<typeof FIELD_CREATION_TYPE>;

type ContradictionCandidate = {
  value: string;
  source_documents: DocsFormSourceDocument[];
  confidence: number;
  rationale: string;
};

type ContradictionResolution = {
  strategy: string;
  selected_value: string;
};

type ContradictionStatus = ValueOf<typeof CONTRADICTION_STATUS>;

export type Contradictions = {
  status: ContradictionStatus;
  candidates: ContradictionCandidate[];
  resolution: ContradictionResolution;
  reasoning?: string;
};

export type SourceFields = {
  manually_edited: boolean;
  creation_type: FieldCreationType;
  source_documents: DocsFormSourceDocument[];
  rating?: DocsFeedbackRatingTypes;
  rating_description?: string;
};

export type FormMetadata<T extends DocsFormName> = {
  approved_by?: ApprovedByType | null;
  schema_version?: SchemaVersion | null;
  source_fields: {
    [key in keyof DocsFormDataMapped<T>]: SourceFields;
  };
  contradictions?: EncryptedField | null;
  is_doctor_approved?: boolean;
};

type DocsFormTypeMapping = {
  [DOCS_FORM_NAMES.DRV_MEDICAL]: DRVMedicalFormData;
  [DOCS_FORM_NAMES.DRV_GENERAL]: DRVGeneralFormData;
  [DOCS_FORM_NAMES.GKV_MEDICAL]: GKVMedicalFormData;
  [DOCS_FORM_NAMES.GKV_GENERAL]: GKVGeneralFormData;
  [DOCS_FORM_NAMES.TRANSITIONAL_CARE]: TransitionalCareFormData;
  [DOCS_FORM_NAMES.DISCHARGE_LETTER_ENT]: DischargeLetterENTFormData;
  [DOCS_FORM_NAMES.DISCHARGE_LETTER_CARDIOLOGY]: DischargeLetterCardiologyFormData;
  [DOCS_FORM_NAMES.DISCHARGE_LETTER_OBSTETRICS]: DischargeLetterObstetricsFormData;
  [DOCS_FORM_NAMES.DISCHARGE_LETTER_NEUROSURGERY]: DischargeLetterNeurosurgeryFormData;
  [DOCS_FORM_NAMES.DISCHARGE_LETTER_SURGERY]: DischargeLetterSurgeryFormData;
  [DOCS_FORM_NAMES.DISCHARGE_LETTER_TRAUMA_SURGERY]: DischargeLetterAccidentSurgeryFormData;
};

export type DocsFormDataMapped<T extends DocsFormName> = DocsFormTypeMapping[T];

export type DocsSubmittedFormData<T extends DocsFormName> = {
  values: DocsFormDataMapped<T>;
};

export type FileDetailsTab = ValueOf<typeof FILE_DETAILS_TABS>;

export type FileDeletionType = ValueOf<typeof FILE_DELETION_TYPES>;

export type FillerOrderId = {
  entity_id: string;
  namespace_id?: string;
};

export type ObservationRequest = {
  set_id?: number;
  filler_order_id?: FillerOrderId;
  universal_service_identifier?: string;
  observation_time?: number | null;
};

export type ObservationResult = {
  set_id?: number;
  observation_value?: string;
  field_name?: string;
  field_label?: string;
  date_time?: number | null;
};

export type Observation = {
  request: ObservationRequest;
  result: ObservationResult[];
};

export type SourceDocumentSource = ValueOf<typeof SOURCE_DOCUMENT_SOURCES>;

export type DocsFeedbackProps = {
  label: string;
  fieldName: string;
  fieldRating?: DocsFeedbackRatingTypes;
  onFieldFeedback?: (feedback: DocsFieldFeedback | null) => void;
  translations: Translations;
};

export type DocsFieldFeedback = {
  label: string;
  fieldName: string;
  rating: DocsFeedbackRatingTypes;
  ratingDescription?: string;
};

export type DocsFeedbackRatingTypes = ValueOf<
  typeof DOCS_FEEDBACK_RATING_TYPES
>;
